//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import dayjs from 'dayjs';

export class DTMWebAPIClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiApplicantsAddressesPost(body: AddressDto[] | undefined, cancelToken?: CancelToken | undefined): Promise<AddressDto[]> {
        let url_ = this.baseUrl + "/api/applicants/addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsAddressesPost(_response);
        });
    }

    protected processApiApplicantsAddressesPost(response: AxiosResponse): Promise<AddressDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AddressDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiApplicantsAddressesGet( cancelToken?: CancelToken | undefined): Promise<AddressDto[]> {
        let url_ = this.baseUrl + "/api/applicants/addresses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsAddressesGet(_response);
        });
    }

    protected processApiApplicantsAddressesGet(response: AxiosResponse): Promise<AddressDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AddressDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiApplicantsAddressGet(addressID: number, cancelToken?: CancelToken | undefined): Promise<AddressDto> {
        let url_ = this.baseUrl + "/api/applicants/address/{addressID}";
        if (addressID === undefined || addressID === null)
            throw new Error("The parameter 'addressID' must be defined.");
        url_ = url_.replace("{addressID}", encodeURIComponent("" + addressID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsAddressGet(_response);
        });
    }

    protected processApiApplicantsAddressGet(response: AxiosResponse): Promise<AddressDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressDto.fromJS(resultData200);
            return Promise.resolve<AddressDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressDto>(null as any);
    }

    /**
     * @param applicantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    apiApplicantsAddressPut(addressID: number, applicantId: number | undefined, body: AddressDto | undefined, cancelToken?: CancelToken | undefined): Promise<IActionResult> {
        let url_ = this.baseUrl + "/api/applicants/address/{addressID}?";
        if (addressID === undefined || addressID === null)
            throw new Error("The parameter 'addressID' must be defined.");
        url_ = url_.replace("{addressID}", encodeURIComponent("" + addressID));
        if (applicantId === null)
            throw new Error("The parameter 'applicantId' cannot be null.");
        else if (applicantId !== undefined)
            url_ += "applicantId=" + encodeURIComponent("" + applicantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsAddressPut(_response);
        });
    }

    protected processApiApplicantsAddressPut(response: AxiosResponse): Promise<IActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IActionResult.fromJS(resultData200);
            return Promise.resolve<IActionResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IActionResult>(null as any);
    }

    /**
     * @return OK
     */
    apiApplicantsAddressDelete(addressID: number, cancelToken?: CancelToken | undefined): Promise<IActionResult> {
        let url_ = this.baseUrl + "/api/applicants/address/{addressID}";
        if (addressID === undefined || addressID === null)
            throw new Error("The parameter 'addressID' must be defined.");
        url_ = url_.replace("{addressID}", encodeURIComponent("" + addressID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsAddressDelete(_response);
        });
    }

    protected processApiApplicantsAddressDelete(response: AxiosResponse): Promise<IActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IActionResult.fromJS(resultData200);
            return Promise.resolve<IActionResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IActionResult>(null as any);
    }

    /**
     * Get applicant details
     * @return Returns a ApplicantForManipulationDto
     */
    apiApplicantsGet( cancelToken?: CancelToken | undefined): Promise<ApplicantForManipulationDto> {
        let url_ = this.baseUrl + "/api/applicants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsGet(_response);
        });
    }

    protected processApiApplicantsGet(response: AxiosResponse): Promise<ApplicantForManipulationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicantForManipulationDto.fromJS(resultData200);
            return Promise.resolve<ApplicantForManipulationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicantForManipulationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiApplicantsPut(body: ApplicantForManipulationDto | undefined, cancelToken?: CancelToken | undefined): Promise<ApplicantForManipulationDto> {
        let url_ = this.baseUrl + "/api/applicants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsPut(_response);
        });
    }

    protected processApiApplicantsPut(response: AxiosResponse): Promise<ApplicantForManipulationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicantForManipulationDto.fromJS(resultData200);
            return Promise.resolve<ApplicantForManipulationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicantForManipulationDto>(null as any);
    }

    /**
     * Check If Applicant Exists in the Applicant Mangement System
     * @param body (optional) 
     * @return Returns True If already a Applicant Exists in the System
     */
    apiApplicantsSearch(body: SearchApplicantModel | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/applicants/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsSearch(_response);
        });
    }

    protected processApiApplicantsSearch(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiApplicantsCreate(body: CreateApplicantModel | undefined, cancelToken?: CancelToken | undefined): Promise<ApplicantForManipulationDto> {
        let url_ = this.baseUrl + "/api/applicants/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsCreate(_response);
        });
    }

    protected processApiApplicantsCreate(response: AxiosResponse): Promise<ApplicantForManipulationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicantForManipulationDto.fromJS(resultData200);
            return Promise.resolve<ApplicantForManipulationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicantForManipulationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiApplicantsCompliance(body: RegulatoryComplainceDto | undefined, cancelToken?: CancelToken | undefined): Promise<RegulatoryComplainceDto> {
        let url_ = this.baseUrl + "/api/applicants/compliance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsCompliance(_response);
        });
    }

    protected processApiApplicantsCompliance(response: AxiosResponse): Promise<RegulatoryComplainceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegulatoryComplainceDto.fromJS(resultData200);
            return Promise.resolve<RegulatoryComplainceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegulatoryComplainceDto>(null as any);
    }

    /**
     * Send a welcome email to an applicant
     * @param email (optional) 
     * @return Returns a boolean
     */
    apiApplicantsWelcome(email: string | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/applicants/welcome?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicantsWelcome(_response);
        });
    }

    protected processApiApplicantsWelcome(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Submit an application to initiate processing and return confirmation email
     * @param body (optional) 
     * @return Returns a boolean
     */
    apiApplicationsSubmit(body: SubmitApplicationDTO | undefined, cancelToken?: CancelToken | undefined): Promise<ApplicantForManipulationDto> {
        let url_ = this.baseUrl + "/api/applications/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicationsSubmit(_response);
        });
    }

    protected processApiApplicationsSubmit(response: AxiosResponse): Promise<ApplicantForManipulationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicantForManipulationDto.fromJS(resultData200);
            return Promise.resolve<ApplicantForManipulationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicantForManipulationDto>(null as any);
    }

    /**
     * Save the application data for a specific applicant
     * @param body (optional) 
     * @return Returns a boolean
     */
    apiApplicationsSave(body: ApplicationDto | undefined, cancelToken?: CancelToken | undefined): Promise<ApplicantForManipulationDto> {
        let url_ = this.baseUrl + "/api/applications/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicationsSave(_response);
        });
    }

    protected processApiApplicationsSave(response: AxiosResponse): Promise<ApplicantForManipulationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicantForManipulationDto.fromJS(resultData200);
            return Promise.resolve<ApplicantForManipulationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicantForManipulationDto>(null as any);
    }

    /**
     * Fetch an application and return its data, including its progress
     * @return Returns a boolean
     */
    apiApplicationsFetch( cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/applications/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiApplicationsFetch(_response);
        });
    }

    protected processApiApplicationsFetch(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Get list of assets by Deal Id
     * @return OK
     */
    apiAssetsGet( cancelToken?: CancelToken | undefined): Promise<DealAssetsDto> {
        let url_ = this.baseUrl + "/api/assets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAssetsGet(_response);
        });
    }

    protected processApiAssetsGet(response: AxiosResponse): Promise<DealAssetsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealAssetsDto.fromJS(resultData200);
            return Promise.resolve<DealAssetsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealAssetsDto>(null as any);
    }

    /**
     * Update Assets for a Deal
     * @param body (optional) A DealAssetsDto model
     * @return return AssetsDto object
     */
    apiAssetsPost(body: DealAssetsDto | undefined, cancelToken?: CancelToken | undefined): Promise<DealAssetsDto> {
        let url_ = this.baseUrl + "/api/assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAssetsPost(_response);
        });
    }

    protected processApiAssetsPost(response: AxiosResponse): Promise<DealAssetsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealAssetsDto.fromJS(resultData200);
            return Promise.resolve<DealAssetsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealAssetsDto>(null as any);
    }

    /**
     * Register new user
     * @param body (optional) A RegisterRequest model
     * @return return AuthenticatedUserDto object
     */
    apiAuthRegister(body: RegisterRequest | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticatedUserDto> {
        let url_ = this.baseUrl + "/api/auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthRegister(_response);
        });
    }

    protected processApiAuthRegister(response: AxiosResponse): Promise<AuthenticatedUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticatedUserDto.fromJS(resultData200);
            return Promise.resolve<AuthenticatedUserDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticatedUserDto>(null as any);
    }

    /**
     * User Login
     * @param body (optional) UserDto
     * @return Returns AuthenticatedUserDto object with access token and refresh token
     */
    apiAuthLogin(body: UserDto | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticatedUserDto> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthLogin(_response);
        });
    }

    protected processApiAuthLogin(response: AxiosResponse): Promise<AuthenticatedUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticatedUserDto.fromJS(resultData200);
            return Promise.resolve<AuthenticatedUserDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticatedUserDto>(null as any);
    }

    /**
     * Generate verification code for twilio
     * @param body (optional) A CreateTwilioCodeCommand model
     * @return Success
     */
    apiAuthGenerateverificationcode(body: CreateTwilioCode | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/auth/generateverificationcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthGenerateverificationcode(_response);
        });
    }

    protected processApiAuthGenerateverificationcode(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Verify twilio generate code
     * @param alloySessionId (optional) Alloy Session ID for verification
     * @param body (optional) A VerifyTwilioCodeCommand model
     * @return Success
     */
    apiAuthVerifycode(alloySessionId: string | undefined, body: VerifyTwilioCode | undefined, cancelToken?: CancelToken | undefined): Promise<TwilioVerifyResult> {
        let url_ = this.baseUrl + "/api/auth/verifycode?";
        if (alloySessionId === null)
            throw new Error("The parameter 'alloySessionId' cannot be null.");
        else if (alloySessionId !== undefined)
            url_ += "alloySessionId=" + encodeURIComponent("" + alloySessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthVerifycode(_response);
        });
    }

    protected processApiAuthVerifycode(response: AxiosResponse): Promise<TwilioVerifyResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TwilioVerifyResult.fromJS(resultData200);
            return Promise.resolve<TwilioVerifyResult>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TwilioVerifyResult>(null as any);
    }

    /**
     * OLB user login with member number
     * @param body (optional) OLBUserDto
     * @return Returns AuthenticatedUserDto object with access token and refresh token
     */
    apiAuthOlblogin(body: OLBUserDto | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticatedUserDto> {
        let url_ = this.baseUrl + "/api/auth/olblogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthOlblogin(_response);
        });
    }

    protected processApiAuthOlblogin(response: AxiosResponse): Promise<AuthenticatedUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticatedUserDto.fromJS(resultData200);
            return Promise.resolve<AuthenticatedUserDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticatedUserDto>(null as any);
    }

    /**
     * OLB user answer 2FA questions
     * @param body (optional) AnswerChallengeDto
     * @return Returns AuthenticatedUserDto object with access token and refresh token
     */
    apiAuthOlbloginAnswerchallenge(body: AnswerChallengeDto | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticatedUserDto> {
        let url_ = this.baseUrl + "/api/auth/olblogin/answerchallenge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthOlbloginAnswerchallenge(_response);
        });
    }

    protected processApiAuthOlbloginAnswerchallenge(response: AxiosResponse): Promise<AuthenticatedUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticatedUserDto.fromJS(resultData200);
            return Promise.resolve<AuthenticatedUserDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticatedUserDto>(null as any);
    }

    /**
     * OLB user remember client device request
     * @param body (optional) RememberClientDto
     * @return Returns RememberClientResultDto
     */
    apiAuthOlbloginRememberclient(body: RememberClientDto | undefined, cancelToken?: CancelToken | undefined): Promise<RememberClientResultDto> {
        let url_ = this.baseUrl + "/api/auth/olblogin/rememberclient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthOlbloginRememberclient(_response);
        });
    }

    protected processApiAuthOlbloginRememberclient(response: AxiosResponse): Promise<RememberClientResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RememberClientResultDto.fromJS(resultData200);
            return Promise.resolve<RememberClientResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RememberClientResultDto>(null as any);
    }

    /**
     * Resend the 2FA verification code via sms or call
     * @param body (optional) SendVerifyCodeDto
     * @return Returns boolean
     */
    apiAuthOlbloginSendverifycode(body: SendVerifyCodeDto | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/auth/olblogin/sendverifycode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthOlbloginSendverifycode(_response);
        });
    }

    protected processApiAuthOlbloginSendverifycode(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Renew the login session using refreshtoken
     * @param body (optional) A TokenData model
     * @return TokenData
     */
    apiAuthRefreshtoken(body: TokenData | undefined, cancelToken?: CancelToken | undefined): Promise<TokenData> {
        let url_ = this.baseUrl + "/api/auth/refreshtoken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthRefreshtoken(_response);
        });
    }

    protected processApiAuthRefreshtoken(response: AxiosResponse): Promise<TokenData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenData.fromJS(resultData200);
            return Promise.resolve<TokenData>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenData>(null as any);
    }

    /**
     * Logout user
     * @param body (optional) A TokenData model
     * @return return null
     */
    apiAuthLogout(body: TokenData | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthLogout(_response);
        });
    }

    protected processApiAuthLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    apiAuthForgotpassword(email: string | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/auth/forgotpassword?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthForgotpassword(_response);
        });
    }

    protected processApiAuthForgotpassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update password for the given username given passwordResetToken
     * @param passwordToken (optional) An Random Unique String
     * @param body (optional) An UpdatePasswordDto
     * @return Returns a boolean for success/failure
     */
    apiAuthUpdatepassword(passwordToken: string | undefined, body: UpdatePasswordDto | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/auth/updatepassword?";
        if (passwordToken === null)
            throw new Error("The parameter 'passwordToken' cannot be null.");
        else if (passwordToken !== undefined)
            url_ += "passwordToken=" + encodeURIComponent("" + passwordToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthUpdatepassword(_response);
        });
    }

    protected processApiAuthUpdatepassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Exchange an external bearer token for an internal token with modified issuer and audience
     * @param token (optional) The external bearer token to exchange via query string
     * @return Returns AuthenticatedUserDto with internal access token and refresh token
     */
    apiAuthSso(token: string | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticatedUserDto> {
        let url_ = this.baseUrl + "/api/auth/sso?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthSso(_response);
        });
    }

    protected processApiAuthSso(response: AxiosResponse): Promise<AuthenticatedUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticatedUserDto.fromJS(resultData200);
            return Promise.resolve<AuthenticatedUserDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticatedUserDto>(null as any);
    }

    /**
     * Get All CoApplicants for a Deal
     * @return Returns a List of Coapplicants
     */
    apiCoapplicantsList( cancelToken?: CancelToken | undefined): Promise<CoApplicantDto[]> {
        let url_ = this.baseUrl + "/api/coapplicants/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiCoapplicantsList(_response);
        });
    }

    protected processApiCoapplicantsList(response: AxiosResponse): Promise<CoApplicantDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoApplicantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CoApplicantDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoApplicantDto[]>(null as any);
    }

    /**
     * Get All CoApplicants by Primary Applicant Name
     * @param primaryApplicantName As primaryApplicantName
     * @return Returns a List of Coapplicants
     */
    apiCoapplicantsFilter(primaryApplicantName: string, cancelToken?: CancelToken | undefined): Promise<CoApplicantDto[]> {
        let url_ = this.baseUrl + "/api/coapplicants/filter/{primaryApplicantName}";
        if (primaryApplicantName === undefined || primaryApplicantName === null)
            throw new Error("The parameter 'primaryApplicantName' must be defined.");
        url_ = url_.replace("{primaryApplicantName}", encodeURIComponent("" + primaryApplicantName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiCoapplicantsFilter(_response);
        });
    }

    protected processApiCoapplicantsFilter(response: AxiosResponse): Promise<CoApplicantDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoApplicantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CoApplicantDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoApplicantDto[]>(null as any);
    }

    /**
     * Get CoApplicant by Invite code
     * @param inviteCode As Unique Param
     * @return Returns a CoApplicant
     */
    apiCoapplicants(inviteCode: string, cancelToken?: CancelToken | undefined): Promise<CoApplicantDto> {
        let url_ = this.baseUrl + "/api/coapplicants/{inviteCode}";
        if (inviteCode === undefined || inviteCode === null)
            throw new Error("The parameter 'inviteCode' must be defined.");
        url_ = url_.replace("{inviteCode}", encodeURIComponent("" + inviteCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiCoapplicants(_response);
        });
    }

    protected processApiCoapplicants(response: AxiosResponse): Promise<CoApplicantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CoApplicantDto.fromJS(resultData200);
            return Promise.resolve<CoApplicantDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoApplicantDto>(null as any);
    }

    /**
     * Add CoApplicant if active deal exists
     * @param body (optional) As CoApplicantForMortgageDto model
     * @return Returns a CoApplicant
     */
    apiCoapplicantsAdd(body: CoApplicantForMortgageDto | undefined, cancelToken?: CancelToken | undefined): Promise<CoApplicantDto> {
        let url_ = this.baseUrl + "/api/coapplicants/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiCoapplicantsAdd(_response);
        });
    }

    protected processApiCoapplicantsAdd(response: AxiosResponse): Promise<CoApplicantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CoApplicantDto.fromJS(resultData200);
            return Promise.resolve<CoApplicantDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoApplicantDto>(null as any);
    }

    /**
     * Update CoApplicant Details
     * @param body (optional) As CoApplicantForMortgageManipulationDto model
     * @return Returns CoApplicant
     */
    apiCoapplicantsUpdate(body: CoApplicantForMortgageManipulationDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/coapplicants/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiCoapplicantsUpdate(_response);
        });
    }

    protected processApiCoapplicantsUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete CoApplicant Details
     * @param inviteCode As inviteCode
     * @return Returns a boolean
     */
    apiCoapplicantsDelete(inviteCode: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/coapplicants/delete/{inviteCode}";
        if (inviteCode === undefined || inviteCode === null)
            throw new Error("The parameter 'inviteCode' must be defined.");
        url_ = url_.replace("{inviteCode}", encodeURIComponent("" + inviteCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiCoapplicantsDelete(_response);
        });
    }

    protected processApiCoapplicantsDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Resend the invite email to the co-applicant
     * @param body (optional) 
     * @return Returns a boolean
     */
    apiCoapplicantsResendinvite(body: NotifyCoApplicantDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/coapplicants/resendinvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiCoapplicantsResendinvite(_response);
        });
    }

    protected processApiCoapplicantsResendinvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add CoApplicant to deal
     * @param dealId As dealId
     * @param body (optional) As CoApplicantForMortgageDto model
     * @return Returns a CoApplicant
     */
    apiCoapplicantsAccept(dealId: number, body: CoApplicantForDealDto | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/coapplicants/accept/{dealId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiCoapplicantsAccept(_response);
        });
    }

    protected processApiCoapplicantsAccept(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Decline CoApplicant Invite
     * @param inviteCode As invited code
     * @return Returns a CoApplicant
     */
    apiCoapplicantsDecline(inviteCode: string, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/coapplicants/decline/{inviteCode}";
        if (inviteCode === undefined || inviteCode === null)
            throw new Error("The parameter 'inviteCode' must be defined.");
        url_ = url_.replace("{inviteCode}", encodeURIComponent("" + inviteCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiCoapplicantsDecline(_response);
        });
    }

    protected processApiCoapplicantsDecline(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get non private config values
     * @return OK
     */
    apiConfig( cancelToken?: CancelToken | undefined): Promise<AppConfig> {
        let url_ = this.baseUrl + "/api/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiConfig(_response);
        });
    }

    protected processApiConfig(response: AxiosResponse): Promise<AppConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppConfig.fromJS(resultData200);
            return Promise.resolve<AppConfig>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppConfig>(null as any);
    }

    /**
     * @return No Content
     */
    apiDataClearcache( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/data/clearcache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDataClearcache(_response);
        });
    }

    protected processApiDataClearcache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    apiDataOccupations( cancelToken?: CancelToken | undefined): Promise<OccupationDto[]> {
        let url_ = this.baseUrl + "/api/data/occupations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDataOccupations(_response);
        });
    }

    protected processApiDataOccupations(response: AxiosResponse): Promise<OccupationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OccupationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OccupationDto[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OccupationDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiDataFinancialinstitutions( cancelToken?: CancelToken | undefined): Promise<FinancialInstitution[]> {
        let url_ = this.baseUrl + "/api/data/financialinstitutions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDataFinancialinstitutions(_response);
        });
    }

    protected processApiDataFinancialinstitutions(response: AxiosResponse): Promise<FinancialInstitution[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialInstitution.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FinancialInstitution[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinancialInstitution[]>(null as any);
    }

    /**
     * @return OK
     */
    apiDataVehiclemakes(year: string, model: string, cancelToken?: CancelToken | undefined): Promise<VehicleModel[]> {
        let url_ = this.baseUrl + "/api/data/vehiclemakes/{year}/{model}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (model === undefined || model === null)
            throw new Error("The parameter 'model' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + model));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDataVehiclemakes(_response);
        });
    }

    protected processApiDataVehiclemakes(response: AxiosResponse): Promise<VehicleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VehicleModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleModel[]>(null as any);
    }

    /**
     * Get Deal Information by Id
     * @return Returns a DealForDashboardDto
     */
    apiDealsGet( cancelToken?: CancelToken | undefined): Promise<MortgageDealDto> {
        let url_ = this.baseUrl + "/api/deals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsGet(_response);
        });
    }

    protected processApiDealsGet(response: AxiosResponse): Promise<MortgageDealDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MortgageDealDto.fromJS(resultData200);
            return Promise.resolve<MortgageDealDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MortgageDealDto>(null as any);
    }

    /**
     * Create a new deal
     * @param body (optional) CreateDealCommand
     * @return Returns DealDto
     */
    apiDealsPost(body: CreateDealCommand | undefined, cancelToken?: CancelToken | undefined): Promise<CreateDealDto> {
        let url_ = this.baseUrl + "/api/deals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsPost(_response);
        });
    }

    protected processApiDealsPost(response: AxiosResponse): Promise<CreateDealDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateDealDto.fromJS(resultData200);
            return Promise.resolve<CreateDealDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateDealDto>(null as any);
    }

    /**
     * Update the Deal Information For a Specific Applicant
     * @param body (optional) UpdateDealCommand
     * @return Returns DealApplicantDto
     */
    apiDealsPut(body: UpdateDealCommand | undefined, cancelToken?: CancelToken | undefined): Promise<DealApplicantDto> {
        let url_ = this.baseUrl + "/api/deals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsPut(_response);
        });
    }

    protected processApiDealsPut(response: AxiosResponse): Promise<DealApplicantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealApplicantDto.fromJS(resultData200);
            return Promise.resolve<DealApplicantDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealApplicantDto>(null as any);
    }

    /**
     * Search Deals by ApplicantId
     * @return Returns a List of DealDto
     */
    apiDealsSearchApplicant( cancelToken?: CancelToken | undefined): Promise<DealDto[]> {
        let url_ = this.baseUrl + "/api/deals/search/applicant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsSearchApplicant(_response);
        });
    }

    protected processApiDealsSearchApplicant(response: AxiosResponse): Promise<DealDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealDto[]>(null as any);
    }

    /**
     * Search Deals by Member Number
     * @return Returns list of DealDto
     */
    apiDealsSearchMember( cancelToken?: CancelToken | undefined): Promise<MortgageDealDto[]> {
        let url_ = this.baseUrl + "/api/deals/search/member";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsSearchMember(_response);
        });
    }

    protected processApiDealsSearchMember(response: AxiosResponse): Promise<MortgageDealDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MortgageDealDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MortgageDealDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MortgageDealDto[]>(null as any);
    }

    /**
     * Create a new property
     * @param body (optional) CreateDealCommand
     * @return Returns PropertyForDisplayDto
     */
    apiDealsApplicationsMortgagesSubjectProperty(body: PropertyForCreationDto | undefined, cancelToken?: CancelToken | undefined): Promise<PropertyForDisplayDto> {
        let url_ = this.baseUrl + "/api/deals/applications/mortgages/subject-property";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsApplicationsMortgagesSubjectProperty(_response);
        });
    }

    protected processApiDealsApplicationsMortgagesSubjectProperty(response: AxiosResponse): Promise<PropertyForDisplayDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyForDisplayDto.fromJS(resultData200);
            return Promise.resolve<PropertyForDisplayDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyForDisplayDto>(null as any);
    }

    /**
     * Get Property Details
     * @param jointCode (optional) 
     * @return Returns PropertyForDisplayDto
     */
    apiDealsApplicationsMortgages(jointCode: string | undefined, cancelToken?: CancelToken | undefined): Promise<PropertyForDisplayDto> {
        let url_ = this.baseUrl + "/api/deals/applications/mortgages?";
        if (jointCode === null)
            throw new Error("The parameter 'jointCode' cannot be null.");
        else if (jointCode !== undefined)
            url_ += "jointCode=" + encodeURIComponent("" + jointCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsApplicationsMortgages(_response);
        });
    }

    protected processApiDealsApplicationsMortgages(response: AxiosResponse): Promise<PropertyForDisplayDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyForDisplayDto.fromJS(resultData200);
            return Promise.resolve<PropertyForDisplayDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyForDisplayDto>(null as any);
    }

    /**
     * Get Application Consent
     * @return Returns ApplicantConsentDto
     */
    apiDealsApplicantConsentGet( cancelToken?: CancelToken | undefined): Promise<ApplicantConsentDto> {
        let url_ = this.baseUrl + "/api/deals/applicant/consent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsApplicantConsentGet(_response);
        });
    }

    protected processApiDealsApplicantConsentGet(response: AxiosResponse): Promise<ApplicantConsentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicantConsentDto.fromJS(resultData200);
            return Promise.resolve<ApplicantConsentDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicantConsentDto>(null as any);
    }

    /**
     * Update Application Consent
     * @param body (optional) AddApplicantConsentCommand
     * @return Returns ApplicantConsentDto
     */
    apiDealsApplicantConsentPost(body: AddApplicantConsentCommand | undefined, cancelToken?: CancelToken | undefined): Promise<IActionResult> {
        let url_ = this.baseUrl + "/api/deals/applicant/consent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsApplicantConsentPost(_response);
        });
    }

    protected processApiDealsApplicantConsentPost(response: AxiosResponse): Promise<IActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IActionResult.fromJS(resultData200);
            return Promise.resolve<IActionResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IActionResult>(null as any);
    }

    /**
     * Amend Existing Member Co-Applicant Status
     * @param body (optional) AmendMemmberCoApplicantCommand
     * @return Returns bool
     */
    apiDealsApplicantMemberAmend(body: AmendMemmberCoApplicantCommand | undefined, cancelToken?: CancelToken | undefined): Promise<IActionResult> {
        let url_ = this.baseUrl + "/api/deals/applicant/member/amend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsApplicantMemberAmend(_response);
        });
    }

    protected processApiDealsApplicantMemberAmend(response: AxiosResponse): Promise<IActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IActionResult.fromJS(resultData200);
            return Promise.resolve<IActionResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IActionResult>(null as any);
    }

    /**
     * Initiate New Deal
     * @return Returns bool
     */
    apiDealsInitiate( cancelToken?: CancelToken | undefined): Promise<IActionResult> {
        let url_ = this.baseUrl + "/api/deals/initiate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsInitiate(_response);
        });
    }

    protected processApiDealsInitiate(response: AxiosResponse): Promise<IActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IActionResult.fromJS(resultData200);
            return Promise.resolve<IActionResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IActionResult>(null as any);
    }

    /**
     * Join a Deal (applies to Co-applicants that have registered, but do not have an active deal)
     * @param body (optional) GetDealById
     * @return Returns bool
     */
    apiDealsJoin(body: GetDealById | undefined, cancelToken?: CancelToken | undefined): Promise<IActionResult> {
        let url_ = this.baseUrl + "/api/deals/join";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsJoin(_response);
        });
    }

    protected processApiDealsJoin(response: AxiosResponse): Promise<IActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IActionResult.fromJS(resultData200);
            return Promise.resolve<IActionResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IActionResult>(null as any);
    }

    /**
     * Detach from a Cancelled Deal (Applies to Co-Applicants Only)
     * @return Returns bool
     */
    apiDealsDetach( cancelToken?: CancelToken | undefined): Promise<IActionResult> {
        let url_ = this.baseUrl + "/api/deals/detach";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiDealsDetach(_response);
        });
    }

    protected processApiDealsDetach(response: AxiosResponse): Promise<IActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IActionResult.fromJS(resultData200);
            return Promise.resolve<IActionResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IActionResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    dociqParse(body: string | undefined, cancelToken?: CancelToken | undefined): Promise<FundmoreRequestDto> {
        let url_ = this.baseUrl + "/dociq/parse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDociqParse(_response);
        });
    }

    protected processDociqParse(response: AxiosResponse): Promise<FundmoreRequestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FundmoreRequestDto.fromJS(resultData200);
            return Promise.resolve<FundmoreRequestDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FundmoreRequestDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    dociqRedirect(body: FundmoreFields | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/dociq/redirect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDociqRedirect(_response);
        });
    }

    protected processDociqRedirect(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get list of employment by Applicant Id
     * @return OK
     */
    apiEmploymentsGet( cancelToken?: CancelToken | undefined): Promise<EmploymentForManipulationDto[]> {
        let url_ = this.baseUrl + "/api/employments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEmploymentsGet(_response);
        });
    }

    protected processApiEmploymentsGet(response: AxiosResponse): Promise<EmploymentForManipulationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmploymentForManipulationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmploymentForManipulationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmploymentForManipulationDto[]>(null as any);
    }

    /**
     * Create new employment record
     * @param body (optional) A CreateEmploymentModel model
     * @return return EmploymentForManipulationDto object
     */
    apiEmploymentsPost(body: CreateEmploymentModel | undefined, cancelToken?: CancelToken | undefined): Promise<EmploymentForManipulationDto[]> {
        let url_ = this.baseUrl + "/api/employments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEmploymentsPost(_response);
        });
    }

    protected processApiEmploymentsPost(response: AxiosResponse): Promise<EmploymentForManipulationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmploymentForManipulationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmploymentForManipulationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmploymentForManipulationDto[]>(null as any);
    }

    /**
     * Update employment record
     * @param body (optional) A UpdateEmploymentModel model
     * @return return EmploymentForManipulationDto object
     */
    apiEmploymentsPut(body: UpdateEmploymentModel | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/employments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEmploymentsPut(_response);
        });
    }

    protected processApiEmploymentsPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete employment record
     * @param body (optional) A DeleteEmploymentModel model
     * @return return EmploymentForManipulationDto object
     */
    apiEmploymentsDelete(body: DeleteEmploymentModel | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/employments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEmploymentsDelete(_response);
        });
    }

    protected processApiEmploymentsDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update previous employment records in bulk
     * @param body (optional) A UpdateEmploymentModel model
     * @return return List(EmploymentForManipulationDto) object
     */
    apiEmploymentsCurrent(body: EmploymentModel | undefined, cancelToken?: CancelToken | undefined): Promise<EmploymentForManipulationDto[]> {
        let url_ = this.baseUrl + "/api/employments/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEmploymentsCurrent(_response);
        });
    }

    protected processApiEmploymentsCurrent(response: AxiosResponse): Promise<EmploymentForManipulationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmploymentForManipulationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmploymentForManipulationDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmploymentForManipulationDto[]>(null as any);
    }

    /**
     * Update previous employment records in bulk
     * @param body (optional) A UpdateEmploymentModel model
     * @return return List(EmploymentForManipulationDto) object
     */
    apiEmploymentsPrevious(body: EmploymentModel | undefined, cancelToken?: CancelToken | undefined): Promise<EmploymentForManipulationDto[]> {
        let url_ = this.baseUrl + "/api/employments/previous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEmploymentsPrevious(_response);
        });
    }

    protected processApiEmploymentsPrevious(response: AxiosResponse): Promise<EmploymentForManipulationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmploymentForManipulationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmploymentForManipulationDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmploymentForManipulationDto[]>(null as any);
    }

    /**
     * Get list of expenses by Deal Id
     * @return OK
     */
    apiExpensesGet( cancelToken?: CancelToken | undefined): Promise<DealExpensesDto> {
        let url_ = this.baseUrl + "/api/expenses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiExpensesGet(_response);
        });
    }

    protected processApiExpensesGet(response: AxiosResponse): Promise<DealExpensesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealExpensesDto.fromJS(resultData200);
            return Promise.resolve<DealExpensesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealExpensesDto>(null as any);
    }

    /**
     * Update Expenses for a Deal
     * @param body (optional) A DealAssetsDto model
     * @return return ExpensesDto object
     */
    apiExpensesPost(body: DealExpensesDto | undefined, cancelToken?: CancelToken | undefined): Promise<DealExpensesDto> {
        let url_ = this.baseUrl + "/api/expenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiExpensesPost(_response);
        });
    }

    protected processApiExpensesPost(response: AxiosResponse): Promise<DealExpensesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealExpensesDto.fromJS(resultData200);
            return Promise.resolve<DealExpensesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealExpensesDto>(null as any);
    }

    /**
     * Get heartbeat of applicant management service
     * @return OK
     */
    apiHeartbeatApplicantmanagement( cancelToken?: CancelToken | undefined): Promise<HeartBeatStatus> {
        let url_ = this.baseUrl + "/api/heartbeat/applicantmanagement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiHeartbeatApplicantmanagement(_response);
        });
    }

    protected processApiHeartbeatApplicantmanagement(response: AxiosResponse): Promise<HeartBeatStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HeartBeatStatus.fromJS(resultData200);
            return Promise.resolve<HeartBeatStatus>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HeartBeatStatus>(null as any);
    }

    /**
     * Get heartbeat of mortgage deals service
     * @return OK
     */
    apiHeartbeatMortgagedeals( cancelToken?: CancelToken | undefined): Promise<HeartBeatStatus> {
        let url_ = this.baseUrl + "/api/heartbeat/mortgagedeals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiHeartbeatMortgagedeals(_response);
        });
    }

    protected processApiHeartbeatMortgagedeals(response: AxiosResponse): Promise<HeartBeatStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HeartBeatStatus.fromJS(resultData200);
            return Promise.resolve<HeartBeatStatus>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HeartBeatStatus>(null as any);
    }

    /**
     * Get heartbeat of identity request service
     * @return OK
     */
    apiHeartbeatIrs( cancelToken?: CancelToken | undefined): Promise<HeartBeatStatus> {
        let url_ = this.baseUrl + "/api/heartbeat/irs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiHeartbeatIrs(_response);
        });
    }

    protected processApiHeartbeatIrs(response: AxiosResponse): Promise<HeartBeatStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HeartBeatStatus.fromJS(resultData200);
            return Promise.resolve<HeartBeatStatus>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HeartBeatStatus>(null as any);
    }

    /**
     * Get heartbeat of admin service
     * @return OK
     */
    apiHeartbeatAdmin( cancelToken?: CancelToken | undefined): Promise<HeartBeatStatus> {
        let url_ = this.baseUrl + "/api/heartbeat/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiHeartbeatAdmin(_response);
        });
    }

    protected processApiHeartbeatAdmin(response: AxiosResponse): Promise<HeartBeatStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HeartBeatStatus.fromJS(resultData200);
            return Promise.resolve<HeartBeatStatus>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HeartBeatStatus>(null as any);
    }

    /**
     * Get heartbeat of rob support service
     * @return OK
     */
    apiHeartbeatRob( cancelToken?: CancelToken | undefined): Promise<HeartBeatStatus> {
        let url_ = this.baseUrl + "/api/heartbeat/rob";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiHeartbeatRob(_response);
        });
    }

    protected processApiHeartbeatRob(response: AxiosResponse): Promise<HeartBeatStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HeartBeatStatus.fromJS(resultData200);
            return Promise.resolve<HeartBeatStatus>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HeartBeatStatus>(null as any);
    }

    /**
     * Initialize IdVerification Application
     * @param body (optional) InitIdVerificationDto
     * @return Returns a bool
     */
    apiIdverificationInit(body: InitIdVerificationDto | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/idverification/init";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiIdverificationInit(_response);
        });
    }

    protected processApiIdverificationInit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Process an ID Verification application
     * @param alloySessionId (optional) The alloy session id associated with the application
     * @param applicationId (optional) Trellis application Id
     * @return Returns an application status
     */
    apiIdverificationProcess(alloySessionId: string | undefined, applicationId: number | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/idverification/process?";
        if (alloySessionId === null)
            throw new Error("The parameter 'alloySessionId' cannot be null.");
        else if (alloySessionId !== undefined)
            url_ += "alloySessionId=" + encodeURIComponent("" + alloySessionId) + "&";
        if (applicationId === null)
            throw new Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiIdverificationProcess(_response);
        });
    }

    protected processApiIdverificationProcess(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Create Block List Check
     * @param body (optional) An Applicant
     * @return Returns a boolean for success/failure
     */
    apiIdverificationBlocklistcheck(body: ApplicantForBlockList | undefined, cancelToken?: CancelToken | undefined): Promise<BlockListSearchResponse> {
        let url_ = this.baseUrl + "/api/idverification/blocklistcheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiIdverificationBlocklistcheck(_response);
        });
    }

    protected processApiIdverificationBlocklistcheck(response: AxiosResponse): Promise<BlockListSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BlockListSearchResponse.fromJS(resultData200);
            return Promise.resolve<BlockListSearchResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BlockListSearchResponse>(null as any);
    }

    /**
     * Create InBranch IDV request
     * @param body (optional) An Applicant
     * @return Returns a VerificationRequestDto
     */
    apiIdverificationInbranchidv(body: ApplicantForIDVDto | undefined, cancelToken?: CancelToken | undefined): Promise<VerificationRequestDto> {
        let url_ = this.baseUrl + "/api/idverification/inbranchidv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiIdverificationInbranchidv(_response);
        });
    }

    protected processApiIdverificationInbranchidv(response: AxiosResponse): Promise<VerificationRequestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerificationRequestDto.fromJS(resultData200);
            return Promise.resolve<VerificationRequestDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerificationRequestDto>(null as any);
    }

    /**
     * Notification for InBranchIDV status updates
     * @param body (optional) IDVNotificationDTO
     * @return Returns a bool
     */
    apiIdverificationInbranchidvnotification(body: IDVNotificationDTO | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/idverification/inbranchidvnotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiIdverificationInbranchidvnotification(_response);
        });
    }

    protected processApiIdverificationInbranchidvnotification(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get all IdVerification statuses
     * @param applicationId (optional) Trellis Application Id
     */
    apiIdverificationIdverificationstatuslist(applicationId: number | undefined, cancelToken?: CancelToken | undefined): Promise<IdVerificationStatusDto[]> {
        let url_ = this.baseUrl + "/api/idverification/idverificationstatuslist?";
        if (applicationId === null)
            throw new Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiIdverificationIdverificationstatuslist(_response);
        });
    }

    protected processApiIdverificationIdverificationstatuslist(response: AxiosResponse): Promise<IdVerificationStatusDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdVerificationStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IdVerificationStatusDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdVerificationStatusDto[]>(null as any);
    }

    /**
     * Get all IdVerification statuses
     */
    apiIdverificationIdverificationapplicant( cancelToken?: CancelToken | undefined): Promise<IdVerificationStatusDto> {
        let url_ = this.baseUrl + "/api/idverification/idverificationapplicant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiIdverificationIdverificationapplicant(_response);
        });
    }

    protected processApiIdverificationIdverificationapplicant(response: AxiosResponse): Promise<IdVerificationStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdVerificationStatusDto.fromJS(resultData200);
            return Promise.resolve<IdVerificationStatusDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdVerificationStatusDto>(null as any);
    }

    /**
     * Manually Update the Status of an ID Application
     * @param alloySessionId (optional) The alloy session id associated with the application
     * @param applicationId (optional) Trellis application Id
     * @return Returns an application status
     */
    apiIdverificationStatus(alloySessionId: string | undefined, applicationId: number | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/idverification/status?";
        if (alloySessionId === null)
            throw new Error("The parameter 'alloySessionId' cannot be null.");
        else if (alloySessionId !== undefined)
            url_ += "alloySessionId=" + encodeURIComponent("" + alloySessionId) + "&";
        if (applicationId === null)
            throw new Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiIdverificationStatus(_response);
        });
    }

    protected processApiIdverificationStatus(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    apiProductsAvailable( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/products/available";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiProductsAvailable(_response);
        });
    }

    protected processApiProductsAvailable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    apiProductsDetail(id: string, cancelToken?: CancelToken | undefined): Promise<OnlineAccountDetailType[]> {
        let url_ = this.baseUrl + "/api/products/detail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiProductsDetail(_response);
        });
    }

    protected processApiProductsDetail(response: AxiosResponse): Promise<OnlineAccountDetailType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnlineAccountDetailType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OnlineAccountDetailType[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OnlineAccountDetailType[]>(null as any);
    }

    /**
     * @return OK
     */
    apiConfigServices( cancelToken?: CancelToken | undefined): Promise<ServicesBuildConfig> {
        let url_ = this.baseUrl + "/api/config/services";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiConfigServices(_response);
        });
    }

    protected processApiConfigServices(response: AxiosResponse): Promise<ServicesBuildConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServicesBuildConfig.fromJS(resultData200);
            return Promise.resolve<ServicesBuildConfig>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServicesBuildConfig>(null as any);
    }
}

/** Root of appsettings.json */
export class AppConfig implements IAppConfig {
    version?: string | undefined;
    services?: ServicesConfig;

    constructor(data?: IAppConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.services = _data["services"] ? ServicesConfig.fromJS(_data["services"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AppConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["services"] = this.services ? this.services.toJSON() : <any>undefined;
        return data;
    }
}

/** Root of appsettings.json */
export interface IAppConfig {
    version?: string | undefined;
    services?: ServicesConfig;
}

export class ServicesBuildConfig implements IServicesBuildConfig {
    servicesBuildVersion?: string | undefined;
    digitalLendingUIBuildVersion?: string | undefined;
    servicesUrl?: ServicesConfig;

    constructor(data?: IServicesBuildConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servicesBuildVersion = _data["servicesBuildVersion"];
            this.digitalLendingUIBuildVersion = _data["digitalLendingUIBuildVersion"];
            this.servicesUrl = _data["servicesUrl"] ? ServicesConfig.fromJS(_data["servicesUrl"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServicesBuildConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesBuildConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servicesBuildVersion"] = this.servicesBuildVersion;
        data["digitalLendingUIBuildVersion"] = this.digitalLendingUIBuildVersion;
        data["servicesUrl"] = this.servicesUrl ? this.servicesUrl.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServicesBuildConfig {
    servicesBuildVersion?: string | undefined;
    digitalLendingUIBuildVersion?: string | undefined;
    servicesUrl?: ServicesConfig;
}

export class ServicesConfig implements IServicesConfig {
    applicantManagementUrl?: string | undefined;
    capUrl?: string | undefined;
    dealUrl?: string | undefined;
    digitalLendingUrl?: string | undefined;
    lendingAdminUrl?: string | undefined;
    obgServiceUrl?: string | undefined;
    onlineBankingUrl?: string | undefined;
    robSupportServiceUrl?: string | undefined;
    vehicleInfoUrl?: string | undefined;
    requestTimeout?: number;

    constructor(data?: IServicesConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantManagementUrl = _data["applicantManagementUrl"];
            this.capUrl = _data["capUrl"];
            this.dealUrl = _data["dealUrl"];
            this.digitalLendingUrl = _data["digitalLendingUrl"];
            this.lendingAdminUrl = _data["lendingAdminUrl"];
            this.obgServiceUrl = _data["obgServiceUrl"];
            this.onlineBankingUrl = _data["onlineBankingUrl"];
            this.robSupportServiceUrl = _data["robSupportServiceUrl"];
            this.vehicleInfoUrl = _data["vehicleInfoUrl"];
            this.requestTimeout = _data["requestTimeout"];
        }
    }

    static fromJS(data: any): ServicesConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantManagementUrl"] = this.applicantManagementUrl;
        data["capUrl"] = this.capUrl;
        data["dealUrl"] = this.dealUrl;
        data["digitalLendingUrl"] = this.digitalLendingUrl;
        data["lendingAdminUrl"] = this.lendingAdminUrl;
        data["obgServiceUrl"] = this.obgServiceUrl;
        data["onlineBankingUrl"] = this.onlineBankingUrl;
        data["robSupportServiceUrl"] = this.robSupportServiceUrl;
        data["vehicleInfoUrl"] = this.vehicleInfoUrl;
        data["requestTimeout"] = this.requestTimeout;
        return data;
    }
}

export interface IServicesConfig {
    applicantManagementUrl?: string | undefined;
    capUrl?: string | undefined;
    dealUrl?: string | undefined;
    digitalLendingUrl?: string | undefined;
    lendingAdminUrl?: string | undefined;
    obgServiceUrl?: string | undefined;
    onlineBankingUrl?: string | undefined;
    robSupportServiceUrl?: string | undefined;
    vehicleInfoUrl?: string | undefined;
    requestTimeout?: number;
}

export class AddApplicantConsentCommand implements IAddApplicantConsentCommand {
    applicantId?: number;
    channel?: string | undefined;

    constructor(data?: IAddApplicantConsentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.channel = _data["channel"];
        }
    }

    static fromJS(data: any): AddApplicantConsentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddApplicantConsentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["channel"] = this.channel;
        return data;
    }
}

export interface IAddApplicantConsentCommand {
    applicantId?: number;
    channel?: string | undefined;
}

export class AmendMemmberCoApplicantCommand implements IAmendMemmberCoApplicantCommand {
    temporaryApplicantId?: number;

    constructor(data?: IAmendMemmberCoApplicantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temporaryApplicantId = _data["temporaryApplicantId"];
        }
    }

    static fromJS(data: any): AmendMemmberCoApplicantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AmendMemmberCoApplicantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temporaryApplicantId"] = this.temporaryApplicantId;
        return data;
    }
}

export interface IAmendMemmberCoApplicantCommand {
    temporaryApplicantId?: number;
}

export class CreateApplicantModel implements ICreateApplicantModel {
    applicant?: ApplicantForRegistrationDto;
    id?: number;
    contactDetailsId?: number;
    memberNo?: number;
    startDate?: dayjs.Dayjs;
    creditScore?: number;
    creditBureauRequestedDate?: dayjs.Dayjs;
    cbConsent?: boolean;
    isStaff?: boolean;
    isPrimary?: boolean;
    complianceInfo?: RegulatoryComplainceDto;
    caslConsent?: boolean;
    idVerification?: boolean;
    residenceStatus?: string | undefined;
    address?: AddressDto[] | undefined;
    mailingAddress?: AddressDto;
    readonly isExisting?: boolean;
    readonly fullName?: string | undefined;
    fmApplicationId?: string | undefined;
    fmApplicantId?: string | undefined;
    title?: string | undefined;
    firstName!: string;
    middleName?: string | undefined;
    lastName!: string;
    dateOfBirth!: dayjs.Dayjs;
    phoneNumber!: string;
    phoneType?: string | undefined;
    sin?: number | undefined;
    email!: string;
    newToCanada?: boolean | undefined;
    student?: boolean | undefined;
    immigrationResident?: boolean | undefined;
    maritalStatus?: string | undefined;
    citizenshipStatus?: string | undefined;
    numberOfDependents?: number;
    alloySessionId?: string | undefined;

    constructor(data?: ICreateApplicantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicant = _data["applicant"] ? ApplicantForRegistrationDto.fromJS(_data["applicant"]) : <any>undefined;
            this.id = _data["id"];
            this.contactDetailsId = _data["contactDetailsId"];
            this.memberNo = _data["memberNo"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : <any>undefined;
            this.creditScore = _data["creditScore"];
            this.creditBureauRequestedDate = _data["creditBureauRequestedDate"] ? dayjs(_data["creditBureauRequestedDate"].toString()) : <any>undefined;
            this.cbConsent = _data["cbConsent"];
            this.isStaff = _data["isStaff"];
            this.isPrimary = _data["isPrimary"];
            this.complianceInfo = _data["complianceInfo"] ? RegulatoryComplainceDto.fromJS(_data["complianceInfo"]) : <any>undefined;
            this.caslConsent = _data["caslConsent"];
            this.idVerification = _data["idVerification"];
            this.residenceStatus = _data["residenceStatus"];
            if (Array.isArray(_data["address"])) {
                this.address = [] as any;
                for (let item of _data["address"])
                    this.address!.push(AddressDto.fromJS(item));
            }
            this.mailingAddress = _data["mailingAddress"] ? AddressDto.fromJS(_data["mailingAddress"]) : <any>undefined;
            (<any>this).isExisting = _data["isExisting"];
            (<any>this).fullName = _data["fullName"];
            this.fmApplicationId = _data["fmApplicationId"];
            this.fmApplicantId = _data["fmApplicantId"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? dayjs(_data["dateOfBirth"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneType = _data["phoneType"];
            this.sin = _data["sin"];
            this.email = _data["email"];
            this.newToCanada = _data["newToCanada"];
            this.student = _data["student"];
            this.immigrationResident = _data["immigrationResident"];
            this.maritalStatus = _data["maritalStatus"];
            this.citizenshipStatus = _data["citizenshipStatus"];
            this.numberOfDependents = _data["numberOfDependents"];
            this.alloySessionId = _data["alloySessionId"];
        }
    }

    static fromJS(data: any): CreateApplicantModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplicantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["contactDetailsId"] = this.contactDetailsId;
        data["memberNo"] = this.memberNo;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["creditScore"] = this.creditScore;
        data["creditBureauRequestedDate"] = this.creditBureauRequestedDate ? this.creditBureauRequestedDate.toISOString() : <any>undefined;
        data["cbConsent"] = this.cbConsent;
        data["isStaff"] = this.isStaff;
        data["isPrimary"] = this.isPrimary;
        data["complianceInfo"] = this.complianceInfo ? this.complianceInfo.toJSON() : <any>undefined;
        data["caslConsent"] = this.caslConsent;
        data["idVerification"] = this.idVerification;
        data["residenceStatus"] = this.residenceStatus;
        if (Array.isArray(this.address)) {
            data["address"] = [];
            for (let item of this.address)
                data["address"].push(item.toJSON());
        }
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>undefined;
        data["isExisting"] = this.isExisting;
        data["fullName"] = this.fullName;
        data["fmApplicationId"] = this.fmApplicationId;
        data["fmApplicantId"] = this.fmApplicantId;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneType"] = this.phoneType;
        data["sin"] = this.sin;
        data["email"] = this.email;
        data["newToCanada"] = this.newToCanada;
        data["student"] = this.student;
        data["immigrationResident"] = this.immigrationResident;
        data["maritalStatus"] = this.maritalStatus;
        data["citizenshipStatus"] = this.citizenshipStatus;
        data["numberOfDependents"] = this.numberOfDependents;
        data["alloySessionId"] = this.alloySessionId;
        return data;
    }
}

export interface ICreateApplicantModel {
    applicant?: ApplicantForRegistrationDto;
    id?: number;
    contactDetailsId?: number;
    memberNo?: number;
    startDate?: dayjs.Dayjs;
    creditScore?: number;
    creditBureauRequestedDate?: dayjs.Dayjs;
    cbConsent?: boolean;
    isStaff?: boolean;
    isPrimary?: boolean;
    complianceInfo?: RegulatoryComplainceDto;
    caslConsent?: boolean;
    idVerification?: boolean;
    residenceStatus?: string | undefined;
    address?: AddressDto[] | undefined;
    mailingAddress?: AddressDto;
    isExisting?: boolean;
    fullName?: string | undefined;
    fmApplicationId?: string | undefined;
    fmApplicantId?: string | undefined;
    title?: string | undefined;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    dateOfBirth: dayjs.Dayjs;
    phoneNumber: string;
    phoneType?: string | undefined;
    sin?: number | undefined;
    email: string;
    newToCanada?: boolean | undefined;
    student?: boolean | undefined;
    immigrationResident?: boolean | undefined;
    maritalStatus?: string | undefined;
    citizenshipStatus?: string | undefined;
    numberOfDependents?: number;
    alloySessionId?: string | undefined;
}

export class SearchApplicantModel implements ISearchApplicantModel {
    firstName!: string;
    lastName!: string;
    sin!: number;
    dateOfBirth!: dayjs.Dayjs;

    constructor(data?: ISearchApplicantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.sin = _data["sin"];
            this.dateOfBirth = _data["dateOfBirth"] ? dayjs(_data["dateOfBirth"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchApplicantModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["sin"] = this.sin;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISearchApplicantModel {
    firstName: string;
    lastName: string;
    sin: number;
    dateOfBirth: dayjs.Dayjs;
}

export class ApplicationDto implements IApplicationDto {
    applicationData?: string | undefined;

    constructor(data?: IApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationData = _data["applicationData"];
        }
    }

    static fromJS(data: any): ApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationData"] = this.applicationData;
        return data;
    }
}

export interface IApplicationDto {
    applicationData?: string | undefined;
}

export class CreateDealCommand implements ICreateDealCommand {
    applicantId?: number;
    deal?: DealForCreationDto;
    mortgageApplication?: MortgageApplicationForCreateDto;
    twilioVerified?: boolean;
    alloySessionId?: string | undefined;
    referralProduct?: ReferralProductDto;
    requestId?: string;
    readonly name?: string | undefined;

    constructor(data?: ICreateDealCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.deal = _data["deal"] ? DealForCreationDto.fromJS(_data["deal"]) : <any>undefined;
            this.mortgageApplication = _data["mortgageApplication"] ? MortgageApplicationForCreateDto.fromJS(_data["mortgageApplication"]) : <any>undefined;
            this.twilioVerified = _data["twilioVerified"];
            this.alloySessionId = _data["alloySessionId"];
            this.referralProduct = _data["referralProduct"] ? ReferralProductDto.fromJS(_data["referralProduct"]) : <any>undefined;
            this.requestId = _data["requestId"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): CreateDealCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDealCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["deal"] = this.deal ? this.deal.toJSON() : <any>undefined;
        data["mortgageApplication"] = this.mortgageApplication ? this.mortgageApplication.toJSON() : <any>undefined;
        data["twilioVerified"] = this.twilioVerified;
        data["alloySessionId"] = this.alloySessionId;
        data["referralProduct"] = this.referralProduct ? this.referralProduct.toJSON() : <any>undefined;
        data["requestId"] = this.requestId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateDealCommand {
    applicantId?: number;
    deal?: DealForCreationDto;
    mortgageApplication?: MortgageApplicationForCreateDto;
    twilioVerified?: boolean;
    alloySessionId?: string | undefined;
    referralProduct?: ReferralProductDto;
    requestId?: string;
    name?: string | undefined;
}

export class GetDealById implements IGetDealById {
    dealId?: number;

    constructor(data?: IGetDealById) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
        }
    }

    static fromJS(data: any): GetDealById {
        data = typeof data === 'object' ? data : {};
        let result = new GetDealById();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        return data;
    }
}

export interface IGetDealById {
    dealId?: number;
}

export class UpdateDealCommand implements IUpdateDealCommand {
    firstTimeHomeBuyer?: boolean;
    relationship?: string | undefined;
    primary?: boolean;
    requestId?: string;
    readonly name?: string | undefined;

    constructor(data?: IUpdateDealCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstTimeHomeBuyer = _data["firstTimeHomeBuyer"];
            this.relationship = _data["relationship"];
            this.primary = _data["primary"];
            this.requestId = _data["requestId"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateDealCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDealCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstTimeHomeBuyer"] = this.firstTimeHomeBuyer;
        data["relationship"] = this.relationship;
        data["primary"] = this.primary;
        data["requestId"] = this.requestId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateDealCommand {
    firstTimeHomeBuyer?: boolean;
    relationship?: string | undefined;
    primary?: boolean;
    requestId?: string;
    name?: string | undefined;
}

export class CreateEmploymentModel implements ICreateEmploymentModel {
    applicantId?: number;
    dealId?: number;
    employment?: EmploymentDto[] | undefined;
    otherIncome?: OtherIncome[] | undefined;

    constructor(data?: ICreateEmploymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.dealId = _data["dealId"];
            if (Array.isArray(_data["employment"])) {
                this.employment = [] as any;
                for (let item of _data["employment"])
                    this.employment!.push(EmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["otherIncome"])) {
                this.otherIncome = [] as any;
                for (let item of _data["otherIncome"])
                    this.otherIncome!.push(OtherIncome.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEmploymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmploymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["dealId"] = this.dealId;
        if (Array.isArray(this.employment)) {
            data["employment"] = [];
            for (let item of this.employment)
                data["employment"].push(item.toJSON());
        }
        if (Array.isArray(this.otherIncome)) {
            data["otherIncome"] = [];
            for (let item of this.otherIncome)
                data["otherIncome"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEmploymentModel {
    applicantId?: number;
    dealId?: number;
    employment?: EmploymentDto[] | undefined;
    otherIncome?: OtherIncome[] | undefined;
}

export class DeleteEmploymentModel implements IDeleteEmploymentModel {
    dealId?: number;
    readonly applicantId?: number;
    employmentId?: number;

    constructor(data?: IDeleteEmploymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            (<any>this).applicantId = _data["applicantId"];
            this.employmentId = _data["employmentId"];
        }
    }

    static fromJS(data: any): DeleteEmploymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmploymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["applicantId"] = this.applicantId;
        data["employmentId"] = this.employmentId;
        return data;
    }
}

export interface IDeleteEmploymentModel {
    dealId?: number;
    applicantId?: number;
    employmentId?: number;
}

export class EmploymentModel implements IEmploymentModel {
    employment?: EmploymentDto[] | undefined;
    otherIncome?: OtherIncome[] | undefined;

    constructor(data?: IEmploymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employment"])) {
                this.employment = [] as any;
                for (let item of _data["employment"])
                    this.employment!.push(EmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["otherIncome"])) {
                this.otherIncome = [] as any;
                for (let item of _data["otherIncome"])
                    this.otherIncome!.push(OtherIncome.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmploymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employment)) {
            data["employment"] = [];
            for (let item of this.employment)
                data["employment"].push(item.toJSON());
        }
        if (Array.isArray(this.otherIncome)) {
            data["otherIncome"] = [];
            for (let item of this.otherIncome)
                data["otherIncome"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmploymentModel {
    employment?: EmploymentDto[] | undefined;
    otherIncome?: OtherIncome[] | undefined;
}

export class UpdateEmploymentModel implements IUpdateEmploymentModel {
    applicantId!: number;
    dealId?: number;
    employment!: EmploymentForManipulationDto;
    otherIncome?: OtherIncome[] | undefined;

    constructor(data?: IUpdateEmploymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.employment = new EmploymentForManipulationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.dealId = _data["dealId"];
            this.employment = _data["employment"] ? EmploymentForManipulationDto.fromJS(_data["employment"]) : new EmploymentForManipulationDto();
            if (Array.isArray(_data["otherIncome"])) {
                this.otherIncome = [] as any;
                for (let item of _data["otherIncome"])
                    this.otherIncome!.push(OtherIncome.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEmploymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmploymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["dealId"] = this.dealId;
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        if (Array.isArray(this.otherIncome)) {
            data["otherIncome"] = [];
            for (let item of this.otherIncome)
                data["otherIncome"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEmploymentModel {
    applicantId: number;
    dealId?: number;
    employment: EmploymentForManipulationDto;
    otherIncome?: OtherIncome[] | undefined;
}

export class HeartBeatStatus implements IHeartBeatStatus {
    status?: string | undefined;
    timestamp?: dayjs.Dayjs;

    constructor(data?: IHeartBeatStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.timestamp = _data["timestamp"] ? dayjs(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HeartBeatStatus {
        data = typeof data === 'object' ? data : {};
        let result = new HeartBeatStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHeartBeatStatus {
    status?: string | undefined;
    timestamp?: dayjs.Dayjs;
}

export class AuthenticatedUserDto implements IAuthenticatedUserDto {
    applicant?: ApplicantForManipulationDto;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    custNo?: number;
    docIqDestination?: string | undefined;
    auth2FA?: LoginResultDto;

    constructor(data?: IAuthenticatedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicant = _data["applicant"] ? ApplicantForManipulationDto.fromJS(_data["applicant"]) : <any>undefined;
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.custNo = _data["custNo"];
            this.docIqDestination = _data["docIqDestination"];
            this.auth2FA = _data["auth2FA"] ? LoginResultDto.fromJS(_data["auth2FA"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthenticatedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticatedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["custNo"] = this.custNo;
        data["docIqDestination"] = this.docIqDestination;
        data["auth2FA"] = this.auth2FA ? this.auth2FA.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthenticatedUserDto {
    applicant?: ApplicantForManipulationDto;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    custNo?: number;
    docIqDestination?: string | undefined;
    auth2FA?: LoginResultDto;
}

export class TokenData implements ITokenData {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: ITokenData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): TokenData {
        data = typeof data === 'object' ? data : {};
        let result = new TokenData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ITokenData {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
}

export class TwilioVerifyResult implements ITwilioVerifyResult {
    checkTriesExceeded?: boolean | undefined;
    codeVerified?: boolean | undefined;
    to?: string | undefined;
    channel?: string | undefined;
    status?: string | undefined;
    sid?: string | undefined;
    accessToken?: string | undefined;

    constructor(data?: ITwilioVerifyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkTriesExceeded = _data["checkTriesExceeded"];
            this.codeVerified = _data["codeVerified"];
            this.to = _data["to"];
            this.channel = _data["channel"];
            this.status = _data["status"];
            this.sid = _data["sid"];
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): TwilioVerifyResult {
        data = typeof data === 'object' ? data : {};
        let result = new TwilioVerifyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkTriesExceeded"] = this.checkTriesExceeded;
        data["codeVerified"] = this.codeVerified;
        data["to"] = this.to;
        data["channel"] = this.channel;
        data["status"] = this.status;
        data["sid"] = this.sid;
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface ITwilioVerifyResult {
    checkTriesExceeded?: boolean | undefined;
    codeVerified?: boolean | undefined;
    to?: string | undefined;
    channel?: string | undefined;
    status?: string | undefined;
    sid?: string | undefined;
    accessToken?: string | undefined;
}

export class CreateTwilioCode implements ICreateTwilioCode {
    /** sms or call */
    verificationType?: string | undefined;
    phoneNumber!: string;

    constructor(data?: ICreateTwilioCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationType = _data["verificationType"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateTwilioCode {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTwilioCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationType"] = this.verificationType;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateTwilioCode {
    /** sms or call */
    verificationType?: string | undefined;
    phoneNumber: string;
}

export class VerifyTwilioCode implements IVerifyTwilioCode {
    phone!: string;
    code!: string;
    attempt?: number;

    constructor(data?: IVerifyTwilioCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.code = _data["code"];
            this.attempt = _data["attempt"];
        }
    }

    static fromJS(data: any): VerifyTwilioCode {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyTwilioCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["code"] = this.code;
        data["attempt"] = this.attempt;
        return data;
    }
}

export interface IVerifyTwilioCode {
    phone: string;
    code: string;
    attempt?: number;
}

export class RegisterRequest implements IRegisterRequest {
    email!: string;
    password!: string;
    meridianCommunication?: boolean;
    inviteCode?: string | undefined;
    docIqToken?: string | undefined;

    constructor(data?: IRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.meridianCommunication = _data["meridianCommunication"];
            this.inviteCode = _data["inviteCode"];
            this.docIqToken = _data["docIqToken"];
        }
    }

    static fromJS(data: any): RegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["meridianCommunication"] = this.meridianCommunication;
        data["inviteCode"] = this.inviteCode;
        data["docIqToken"] = this.docIqToken;
        return data;
    }
}

export interface IRegisterRequest {
    email: string;
    password: string;
    meridianCommunication?: boolean;
    inviteCode?: string | undefined;
    docIqToken?: string | undefined;
}

export class NotifyCoApplicantDTO implements INotifyCoApplicantDTO {
    primaryApplicantName!: string;
    coApplicantName!: string;
    email!: string;
    inviteCode!: string;

    constructor(data?: INotifyCoApplicantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryApplicantName = _data["primaryApplicantName"];
            this.coApplicantName = _data["coApplicantName"];
            this.email = _data["email"];
            this.inviteCode = _data["inviteCode"];
        }
    }

    static fromJS(data: any): NotifyCoApplicantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyCoApplicantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryApplicantName"] = this.primaryApplicantName;
        data["coApplicantName"] = this.coApplicantName;
        data["email"] = this.email;
        data["inviteCode"] = this.inviteCode;
        return data;
    }
}

export interface INotifyCoApplicantDTO {
    primaryApplicantName: string;
    coApplicantName: string;
    email: string;
    inviteCode: string;
}

export class SubmitApplicationDTO implements ISubmitApplicationDTO {
    applicantId?: number;
    dealApplicantType?: string | undefined;
    applicantName?: string | undefined;
    applicantEmail?: string | undefined;

    constructor(data?: ISubmitApplicationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.dealApplicantType = _data["dealApplicantType"];
            this.applicantName = _data["applicantName"];
            this.applicantEmail = _data["applicantEmail"];
        }
    }

    static fromJS(data: any): SubmitApplicationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitApplicationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["dealApplicantType"] = this.dealApplicantType;
        data["applicantName"] = this.applicantName;
        data["applicantEmail"] = this.applicantEmail;
        return data;
    }
}

export interface ISubmitApplicationDTO {
    applicantId?: number;
    dealApplicantType?: string | undefined;
    applicantName?: string | undefined;
    applicantEmail?: string | undefined;
}

export class ApplicantForIDVDto implements IApplicantForIDVDto {
    alloySessionId?: string | undefined;
    applicantId?: number;
    primaryAddress?: Address;
    mailingAddress?: Address;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    phoneType?: string | undefined;
    dateOfBirth?: string | undefined;
    sin?: string | undefined;

    constructor(data?: IApplicantForIDVDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alloySessionId = _data["alloySessionId"];
            this.applicantId = _data["applicantId"];
            this.primaryAddress = _data["primaryAddress"] ? Address.fromJS(_data["primaryAddress"]) : <any>undefined;
            this.mailingAddress = _data["mailingAddress"] ? Address.fromJS(_data["mailingAddress"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneType = _data["phoneType"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.sin = _data["sin"];
        }
    }

    static fromJS(data: any): ApplicantForIDVDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantForIDVDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alloySessionId"] = this.alloySessionId;
        data["applicantId"] = this.applicantId;
        data["primaryAddress"] = this.primaryAddress ? this.primaryAddress.toJSON() : <any>undefined;
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneType"] = this.phoneType;
        data["dateOfBirth"] = this.dateOfBirth;
        data["sin"] = this.sin;
        return data;
    }
}

export interface IApplicantForIDVDto {
    alloySessionId?: string | undefined;
    applicantId?: number;
    primaryAddress?: Address;
    mailingAddress?: Address;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    phoneType?: string | undefined;
    dateOfBirth?: string | undefined;
    sin?: string | undefined;
}

export class IdVerificationStatusDto implements IIdVerificationStatusDto {
    applicantId?: number;
    applicationId?: number;
    status?: string | undefined;
    alloySessionId?: string | undefined;

    constructor(data?: IIdVerificationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.applicationId = _data["applicationId"];
            this.status = _data["status"];
            this.alloySessionId = _data["alloySessionId"];
        }
    }

    static fromJS(data: any): IdVerificationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdVerificationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["applicationId"] = this.applicationId;
        data["status"] = this.status;
        data["alloySessionId"] = this.alloySessionId;
        return data;
    }
}

export interface IIdVerificationStatusDto {
    applicantId?: number;
    applicationId?: number;
    status?: string | undefined;
    alloySessionId?: string | undefined;
}

export class InitIdVerificationDto implements IInitIdVerificationDto {
    alloySessionId?: string | undefined;
    applicationId?: number;
    applicantId?: number;
    status?: string | undefined;
    phoneVerified?: boolean;

    constructor(data?: IInitIdVerificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alloySessionId = _data["alloySessionId"];
            this.applicationId = _data["applicationId"];
            this.applicantId = _data["applicantId"];
            this.status = _data["status"];
            this.phoneVerified = _data["phoneVerified"];
        }
    }

    static fromJS(data: any): InitIdVerificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitIdVerificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alloySessionId"] = this.alloySessionId;
        data["applicationId"] = this.applicationId;
        data["applicantId"] = this.applicantId;
        data["status"] = this.status;
        data["phoneVerified"] = this.phoneVerified;
        return data;
    }
}

export interface IInitIdVerificationDto {
    alloySessionId?: string | undefined;
    applicationId?: number;
    applicantId?: number;
    status?: string | undefined;
    phoneVerified?: boolean;
}

export class AnswerChallengeDto implements IAnswerChallengeDto {
    username?: string | undefined;
    sessionId?: string | undefined;
    answer?: string | undefined;
    dealId?: number;
    docIqToken?: string | undefined;

    constructor(data?: IAnswerChallengeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.sessionId = _data["sessionId"];
            this.answer = _data["answer"];
            this.dealId = _data["dealId"];
            this.docIqToken = _data["docIqToken"];
        }
    }

    static fromJS(data: any): AnswerChallengeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerChallengeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["sessionId"] = this.sessionId;
        data["answer"] = this.answer;
        data["dealId"] = this.dealId;
        data["docIqToken"] = this.docIqToken;
        return data;
    }
}

export interface IAnswerChallengeDto {
    username?: string | undefined;
    sessionId?: string | undefined;
    answer?: string | undefined;
    dealId?: number;
    docIqToken?: string | undefined;
}

export class LoginResultDto implements ILoginResultDto {
    sessionId?: string | undefined;
    challenge2FA?: Challenge2FA;
    challengeQuestion?: ChallengeQuestion;

    constructor(data?: ILoginResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.challenge2FA = _data["challenge2FA"] ? Challenge2FA.fromJS(_data["challenge2FA"]) : <any>undefined;
            this.challengeQuestion = _data["challengeQuestion"] ? ChallengeQuestion.fromJS(_data["challengeQuestion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["challenge2FA"] = this.challenge2FA ? this.challenge2FA.toJSON() : <any>undefined;
        data["challengeQuestion"] = this.challengeQuestion ? this.challengeQuestion.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginResultDto {
    sessionId?: string | undefined;
    challenge2FA?: Challenge2FA;
    challengeQuestion?: ChallengeQuestion;
}

export class OLBUserDto implements IOLBUserDto {
    username!: string;
    password!: string;
    clientToken?: string | undefined;

    constructor(data?: IOLBUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.clientToken = _data["clientToken"];
        }
    }

    static fromJS(data: any): OLBUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new OLBUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["clientToken"] = this.clientToken;
        return data;
    }
}

export interface IOLBUserDto {
    username: string;
    password: string;
    clientToken?: string | undefined;
}

export class RememberClientDto implements IRememberClientDto {
    sessionId?: string | undefined;
    clientToken?: string | undefined;

    constructor(data?: IRememberClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.clientToken = _data["clientToken"];
        }
    }

    static fromJS(data: any): RememberClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new RememberClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["clientToken"] = this.clientToken;
        return data;
    }
}

export interface IRememberClientDto {
    sessionId?: string | undefined;
    clientToken?: string | undefined;
}

export class RememberClientResultDto implements IRememberClientResultDto {
    clientToken?: string | undefined;
    clientTokenExpiry?: string | undefined;

    constructor(data?: IRememberClientResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientToken = _data["clientToken"];
            this.clientTokenExpiry = _data["clientTokenExpiry"];
        }
    }

    static fromJS(data: any): RememberClientResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RememberClientResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientToken"] = this.clientToken;
        data["clientTokenExpiry"] = this.clientTokenExpiry;
        return data;
    }
}

export interface IRememberClientResultDto {
    clientToken?: string | undefined;
    clientTokenExpiry?: string | undefined;
}

export class SendVerifyCodeDto implements ISendVerifyCodeDto {
    sessionId?: string | undefined;
    channel?: string | undefined;

    constructor(data?: ISendVerifyCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.channel = _data["channel"];
        }
    }

    static fromJS(data: any): SendVerifyCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerifyCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["channel"] = this.channel;
        return data;
    }
}

export interface ISendVerifyCodeDto {
    sessionId?: string | undefined;
    channel?: string | undefined;
}

export class VehicleModel implements IVehicleModel {
    make_ID?: string | undefined;
    make_Name?: string | undefined;
    model_ID?: string | undefined;
    model_Name?: string | undefined;

    constructor(data?: IVehicleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.make_ID = _data["make_ID"];
            this.make_Name = _data["make_Name"];
            this.model_ID = _data["model_ID"];
            this.model_Name = _data["model_Name"];
        }
    }

    static fromJS(data: any): VehicleModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["make_ID"] = this.make_ID;
        data["make_Name"] = this.make_Name;
        data["model_ID"] = this.model_ID;
        data["model_Name"] = this.model_Name;
        return data;
    }
}

export interface IVehicleModel {
    make_ID?: string | undefined;
    make_Name?: string | undefined;
    model_ID?: string | undefined;
    model_Name?: string | undefined;
}

export class ApplicantConsentDto implements IApplicantConsentDto {
    date?: dayjs.Dayjs | undefined;
    type?: string | undefined;
    channel?: string | undefined;

    constructor(data?: IApplicantConsentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.channel = _data["channel"];
        }
    }

    static fromJS(data: any): ApplicantConsentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantConsentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["channel"] = this.channel;
        return data;
    }
}

export interface IApplicantConsentDto {
    date?: dayjs.Dayjs | undefined;
    type?: string | undefined;
    channel?: string | undefined;
}

export class ApplicantForBlockList implements IApplicantForBlockList {
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: string | undefined;
    alloySessionId?: string | undefined;
    applicationId?: number;
    alloySessionCreated?: boolean;

    constructor(data?: IApplicantForBlockList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"];
            this.alloySessionId = _data["alloySessionId"];
            this.applicationId = _data["applicationId"];
            this.alloySessionCreated = _data["alloySessionCreated"];
        }
    }

    static fromJS(data: any): ApplicantForBlockList {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantForBlockList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate;
        data["alloySessionId"] = this.alloySessionId;
        data["applicationId"] = this.applicationId;
        data["alloySessionCreated"] = this.alloySessionCreated;
        return data;
    }
}

export interface IApplicantForBlockList {
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: string | undefined;
    alloySessionId?: string | undefined;
    applicationId?: number;
    alloySessionCreated?: boolean;
}

export class ApplicantForManipulationDto implements IApplicantForManipulationDto {
    id?: number;
    contactDetailsId?: number;
    memberNo?: number;
    startDate?: dayjs.Dayjs;
    creditScore?: number;
    creditBureauRequestedDate?: dayjs.Dayjs;
    cbConsent?: boolean;
    isStaff?: boolean;
    isPrimary?: boolean;
    complianceInfo?: RegulatoryComplainceDto;
    caslConsent?: boolean;
    idVerification?: boolean;
    residenceStatus?: string | undefined;
    address?: AddressDto[] | undefined;
    mailingAddress?: AddressDto;
    readonly isExisting?: boolean;
    readonly fullName?: string | undefined;
    fmApplicationId?: string | undefined;
    fmApplicantId?: string | undefined;
    title?: string | undefined;
    firstName!: string;
    middleName?: string | undefined;
    lastName!: string;
    dateOfBirth!: dayjs.Dayjs;
    phoneNumber!: string;
    phoneType?: string | undefined;
    sin?: number | undefined;
    email!: string;
    newToCanada?: boolean | undefined;
    student?: boolean | undefined;
    immigrationResident?: boolean | undefined;
    maritalStatus?: string | undefined;
    citizenshipStatus?: string | undefined;
    numberOfDependents?: number;
    alloySessionId?: string | undefined;

    constructor(data?: IApplicantForManipulationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactDetailsId = _data["contactDetailsId"];
            this.memberNo = _data["memberNo"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : <any>undefined;
            this.creditScore = _data["creditScore"];
            this.creditBureauRequestedDate = _data["creditBureauRequestedDate"] ? dayjs(_data["creditBureauRequestedDate"].toString()) : <any>undefined;
            this.cbConsent = _data["cbConsent"];
            this.isStaff = _data["isStaff"];
            this.isPrimary = _data["isPrimary"];
            this.complianceInfo = _data["complianceInfo"] ? RegulatoryComplainceDto.fromJS(_data["complianceInfo"]) : <any>undefined;
            this.caslConsent = _data["caslConsent"];
            this.idVerification = _data["idVerification"];
            this.residenceStatus = _data["residenceStatus"];
            if (Array.isArray(_data["address"])) {
                this.address = [] as any;
                for (let item of _data["address"])
                    this.address!.push(AddressDto.fromJS(item));
            }
            this.mailingAddress = _data["mailingAddress"] ? AddressDto.fromJS(_data["mailingAddress"]) : <any>undefined;
            (<any>this).isExisting = _data["isExisting"];
            (<any>this).fullName = _data["fullName"];
            this.fmApplicationId = _data["fmApplicationId"];
            this.fmApplicantId = _data["fmApplicantId"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? dayjs(_data["dateOfBirth"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneType = _data["phoneType"];
            this.sin = _data["sin"];
            this.email = _data["email"];
            this.newToCanada = _data["newToCanada"];
            this.student = _data["student"];
            this.immigrationResident = _data["immigrationResident"];
            this.maritalStatus = _data["maritalStatus"];
            this.citizenshipStatus = _data["citizenshipStatus"];
            this.numberOfDependents = _data["numberOfDependents"];
            this.alloySessionId = _data["alloySessionId"];
        }
    }

    static fromJS(data: any): ApplicantForManipulationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantForManipulationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactDetailsId"] = this.contactDetailsId;
        data["memberNo"] = this.memberNo;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["creditScore"] = this.creditScore;
        data["creditBureauRequestedDate"] = this.creditBureauRequestedDate ? this.creditBureauRequestedDate.toISOString() : <any>undefined;
        data["cbConsent"] = this.cbConsent;
        data["isStaff"] = this.isStaff;
        data["isPrimary"] = this.isPrimary;
        data["complianceInfo"] = this.complianceInfo ? this.complianceInfo.toJSON() : <any>undefined;
        data["caslConsent"] = this.caslConsent;
        data["idVerification"] = this.idVerification;
        data["residenceStatus"] = this.residenceStatus;
        if (Array.isArray(this.address)) {
            data["address"] = [];
            for (let item of this.address)
                data["address"].push(item.toJSON());
        }
        data["mailingAddress"] = this.mailingAddress ? this.mailingAddress.toJSON() : <any>undefined;
        data["isExisting"] = this.isExisting;
        data["fullName"] = this.fullName;
        data["fmApplicationId"] = this.fmApplicationId;
        data["fmApplicantId"] = this.fmApplicantId;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneType"] = this.phoneType;
        data["sin"] = this.sin;
        data["email"] = this.email;
        data["newToCanada"] = this.newToCanada;
        data["student"] = this.student;
        data["immigrationResident"] = this.immigrationResident;
        data["maritalStatus"] = this.maritalStatus;
        data["citizenshipStatus"] = this.citizenshipStatus;
        data["numberOfDependents"] = this.numberOfDependents;
        data["alloySessionId"] = this.alloySessionId;
        return data;
    }
}

export interface IApplicantForManipulationDto {
    id?: number;
    contactDetailsId?: number;
    memberNo?: number;
    startDate?: dayjs.Dayjs;
    creditScore?: number;
    creditBureauRequestedDate?: dayjs.Dayjs;
    cbConsent?: boolean;
    isStaff?: boolean;
    isPrimary?: boolean;
    complianceInfo?: RegulatoryComplainceDto;
    caslConsent?: boolean;
    idVerification?: boolean;
    residenceStatus?: string | undefined;
    address?: AddressDto[] | undefined;
    mailingAddress?: AddressDto;
    isExisting?: boolean;
    fullName?: string | undefined;
    fmApplicationId?: string | undefined;
    fmApplicantId?: string | undefined;
    title?: string | undefined;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    dateOfBirth: dayjs.Dayjs;
    phoneNumber: string;
    phoneType?: string | undefined;
    sin?: number | undefined;
    email: string;
    newToCanada?: boolean | undefined;
    student?: boolean | undefined;
    immigrationResident?: boolean | undefined;
    maritalStatus?: string | undefined;
    citizenshipStatus?: string | undefined;
    numberOfDependents?: number;
    alloySessionId?: string | undefined;
}

export class ApplicantForRegistrationDto implements IApplicantForRegistrationDto {
    cbConsent?: boolean;
    caslConsent?: boolean;
    permanentResident?: boolean;
    title?: string | undefined;
    firstName!: string;
    middleName?: string | undefined;
    lastName!: string;
    dateOfBirth!: dayjs.Dayjs;
    phoneNumber!: string;
    phoneType?: string | undefined;
    sin?: number | undefined;
    email!: string;
    newToCanada?: boolean | undefined;
    student?: boolean | undefined;
    immigrationResident?: boolean | undefined;
    maritalStatus?: string | undefined;
    citizenshipStatus?: string | undefined;
    numberOfDependents?: number;
    alloySessionId?: string | undefined;

    constructor(data?: IApplicantForRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cbConsent = _data["cbConsent"];
            this.caslConsent = _data["caslConsent"];
            this.permanentResident = _data["permanentResident"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? dayjs(_data["dateOfBirth"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneType = _data["phoneType"];
            this.sin = _data["sin"];
            this.email = _data["email"];
            this.newToCanada = _data["newToCanada"];
            this.student = _data["student"];
            this.immigrationResident = _data["immigrationResident"];
            this.maritalStatus = _data["maritalStatus"];
            this.citizenshipStatus = _data["citizenshipStatus"];
            this.numberOfDependents = _data["numberOfDependents"];
            this.alloySessionId = _data["alloySessionId"];
        }
    }

    static fromJS(data: any): ApplicantForRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantForRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cbConsent"] = this.cbConsent;
        data["caslConsent"] = this.caslConsent;
        data["permanentResident"] = this.permanentResident;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneType"] = this.phoneType;
        data["sin"] = this.sin;
        data["email"] = this.email;
        data["newToCanada"] = this.newToCanada;
        data["student"] = this.student;
        data["immigrationResident"] = this.immigrationResident;
        data["maritalStatus"] = this.maritalStatus;
        data["citizenshipStatus"] = this.citizenshipStatus;
        data["numberOfDependents"] = this.numberOfDependents;
        data["alloySessionId"] = this.alloySessionId;
        return data;
    }
}

export interface IApplicantForRegistrationDto {
    cbConsent?: boolean;
    caslConsent?: boolean;
    permanentResident?: boolean;
    title?: string | undefined;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    dateOfBirth: dayjs.Dayjs;
    phoneNumber: string;
    phoneType?: string | undefined;
    sin?: number | undefined;
    email: string;
    newToCanada?: boolean | undefined;
    student?: boolean | undefined;
    immigrationResident?: boolean | undefined;
    maritalStatus?: string | undefined;
    citizenshipStatus?: string | undefined;
    numberOfDependents?: number;
    alloySessionId?: string | undefined;
}

export class CoApplicantDto implements ICoApplicantDto {
    dateOfBirth?: dayjs.Dayjs | undefined;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    relationship?: string | undefined;
    isActiveLink?: boolean;
    dealId?: number;
    applicantId?: number;
    inviteCode?: string | undefined;
    primaryApplicant?: string | undefined;
    readonly created?: dayjs.Dayjs;
    readonly expires?: dayjs.Dayjs;
    readonly updatedDate?: dayjs.Dayjs;
    phoneNumber?: string | undefined;
    readonly id?: number;

    constructor(data?: ICoApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfBirth = _data["dateOfBirth"] ? dayjs(_data["dateOfBirth"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.relationship = _data["relationship"];
            this.isActiveLink = _data["isActiveLink"];
            this.dealId = _data["dealId"];
            this.applicantId = _data["applicantId"];
            this.inviteCode = _data["inviteCode"];
            this.primaryApplicant = _data["primaryApplicant"];
            (<any>this).created = _data["created"] ? dayjs(_data["created"].toString()) : <any>undefined;
            (<any>this).expires = _data["expires"] ? dayjs(_data["expires"].toString()) : <any>undefined;
            (<any>this).updatedDate = _data["updatedDate"] ? dayjs(_data["updatedDate"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): CoApplicantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["relationship"] = this.relationship;
        data["isActiveLink"] = this.isActiveLink;
        data["dealId"] = this.dealId;
        data["applicantId"] = this.applicantId;
        data["inviteCode"] = this.inviteCode;
        data["primaryApplicant"] = this.primaryApplicant;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface ICoApplicantDto {
    dateOfBirth?: dayjs.Dayjs | undefined;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    relationship?: string | undefined;
    isActiveLink?: boolean;
    dealId?: number;
    applicantId?: number;
    inviteCode?: string | undefined;
    primaryApplicant?: string | undefined;
    created?: dayjs.Dayjs;
    expires?: dayjs.Dayjs;
    updatedDate?: dayjs.Dayjs;
    phoneNumber?: string | undefined;
    id?: number;
}

export class CoApplicantForDealDto implements ICoApplicantForDealDto {
    applicantId!: number;
    firstTimeHomeBuyer?: boolean;
    twilioVerified?: boolean;
    alloySessionId?: string | undefined;
    code!: string;
    firstName!: string;
    lastName!: string;
    emailAddress!: string;
    relationship!: string;
    applicationtype?: string | undefined;
    expirationDate?: dayjs.Dayjs;
    isActiveLink?: boolean;

    constructor(data?: ICoApplicantForDealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.firstTimeHomeBuyer = _data["firstTimeHomeBuyer"];
            this.twilioVerified = _data["twilioVerified"];
            this.alloySessionId = _data["alloySessionId"];
            this.code = _data["code"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.relationship = _data["relationship"];
            this.applicationtype = _data["applicationtype"];
            this.expirationDate = _data["expirationDate"] ? dayjs(_data["expirationDate"].toString()) : <any>undefined;
            this.isActiveLink = _data["isActiveLink"];
        }
    }

    static fromJS(data: any): CoApplicantForDealDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoApplicantForDealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["firstTimeHomeBuyer"] = this.firstTimeHomeBuyer;
        data["twilioVerified"] = this.twilioVerified;
        data["alloySessionId"] = this.alloySessionId;
        data["code"] = this.code;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["relationship"] = this.relationship;
        data["applicationtype"] = this.applicationtype;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["isActiveLink"] = this.isActiveLink;
        return data;
    }
}

export interface ICoApplicantForDealDto {
    applicantId: number;
    firstTimeHomeBuyer?: boolean;
    twilioVerified?: boolean;
    alloySessionId?: string | undefined;
    code: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    relationship: string;
    applicationtype?: string | undefined;
    expirationDate?: dayjs.Dayjs;
    isActiveLink?: boolean;
}

export class CoApplicantForMortgageDto implements ICoApplicantForMortgageDto {
    firstName!: string;
    lastName!: string;
    emailAddress!: string;
    relationship!: string;
    mainApplicantName!: string;
    dateOfBirth!: dayjs.Dayjs;
    phoneNumber?: string | undefined;

    constructor(data?: ICoApplicantForMortgageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.relationship = _data["relationship"];
            this.mainApplicantName = _data["mainApplicantName"];
            this.dateOfBirth = _data["dateOfBirth"] ? dayjs(_data["dateOfBirth"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CoApplicantForMortgageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoApplicantForMortgageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["relationship"] = this.relationship;
        data["mainApplicantName"] = this.mainApplicantName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICoApplicantForMortgageDto {
    firstName: string;
    lastName: string;
    emailAddress: string;
    relationship: string;
    mainApplicantName: string;
    dateOfBirth: dayjs.Dayjs;
    phoneNumber?: string | undefined;
}

export class CoApplicantForMortgageManipulationDto implements ICoApplicantForMortgageManipulationDto {
    code?: string | undefined;
    isActiveLink?: boolean;
    firstName!: string;
    lastName!: string;
    emailAddress!: string;
    relationship!: string;
    mainApplicantName!: string;
    dateOfBirth!: dayjs.Dayjs;
    phoneNumber?: string | undefined;

    constructor(data?: ICoApplicantForMortgageManipulationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.isActiveLink = _data["isActiveLink"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.relationship = _data["relationship"];
            this.mainApplicantName = _data["mainApplicantName"];
            this.dateOfBirth = _data["dateOfBirth"] ? dayjs(_data["dateOfBirth"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CoApplicantForMortgageManipulationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoApplicantForMortgageManipulationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isActiveLink"] = this.isActiveLink;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["relationship"] = this.relationship;
        data["mainApplicantName"] = this.mainApplicantName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICoApplicantForMortgageManipulationDto {
    code?: string | undefined;
    isActiveLink?: boolean;
    firstName: string;
    lastName: string;
    emailAddress: string;
    relationship: string;
    mainApplicantName: string;
    dateOfBirth: dayjs.Dayjs;
    phoneNumber?: string | undefined;
}

export class OtherIncome implements IOtherIncome {
    twoPlusYears?: boolean | undefined;
    id?: number;
    incomeCategoryType_Name?: string | undefined;
    incomeType_Name?: string | undefined;
    applicantId?: number;
    dealId?: number;
    currencyType_Name?: string | undefined;
    frequencyType_Name?: string | undefined;
    amountPerFrequency?: number;
    description?: string | undefined;
    country?: string | undefined;
    sinceDate?: dayjs.Dayjs | undefined;
    conversionRate?: number | undefined;
    conversionRateDate?: dayjs.Dayjs | undefined;
    primaryIncomeSource?: boolean | undefined;

    constructor(data?: IOtherIncome) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.twoPlusYears = _data["twoPlusYears"];
            this.id = _data["id"];
            this.incomeCategoryType_Name = _data["incomeCategoryType_Name"];
            this.incomeType_Name = _data["incomeType_Name"];
            this.applicantId = _data["applicantId"];
            this.dealId = _data["dealId"];
            this.currencyType_Name = _data["currencyType_Name"];
            this.frequencyType_Name = _data["frequencyType_Name"];
            this.amountPerFrequency = _data["amountPerFrequency"];
            this.description = _data["description"];
            this.country = _data["country"];
            this.sinceDate = _data["sinceDate"] ? dayjs(_data["sinceDate"].toString()) : <any>undefined;
            this.conversionRate = _data["conversionRate"];
            this.conversionRateDate = _data["conversionRateDate"] ? dayjs(_data["conversionRateDate"].toString()) : <any>undefined;
            this.primaryIncomeSource = _data["primaryIncomeSource"];
        }
    }

    static fromJS(data: any): OtherIncome {
        data = typeof data === 'object' ? data : {};
        let result = new OtherIncome();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["twoPlusYears"] = this.twoPlusYears;
        data["id"] = this.id;
        data["incomeCategoryType_Name"] = this.incomeCategoryType_Name;
        data["incomeType_Name"] = this.incomeType_Name;
        data["applicantId"] = this.applicantId;
        data["dealId"] = this.dealId;
        data["currencyType_Name"] = this.currencyType_Name;
        data["frequencyType_Name"] = this.frequencyType_Name;
        data["amountPerFrequency"] = this.amountPerFrequency;
        data["description"] = this.description;
        data["country"] = this.country;
        data["sinceDate"] = this.sinceDate ? this.sinceDate.toISOString() : <any>undefined;
        data["conversionRate"] = this.conversionRate;
        data["conversionRateDate"] = this.conversionRateDate ? this.conversionRateDate.toISOString() : <any>undefined;
        data["primaryIncomeSource"] = this.primaryIncomeSource;
        return data;
    }
}

export interface IOtherIncome {
    twoPlusYears?: boolean | undefined;
    id?: number;
    incomeCategoryType_Name?: string | undefined;
    incomeType_Name?: string | undefined;
    applicantId?: number;
    dealId?: number;
    currencyType_Name?: string | undefined;
    frequencyType_Name?: string | undefined;
    amountPerFrequency?: number;
    description?: string | undefined;
    country?: string | undefined;
    sinceDate?: dayjs.Dayjs | undefined;
    conversionRate?: number | undefined;
    conversionRateDate?: dayjs.Dayjs | undefined;
    primaryIncomeSource?: boolean | undefined;
}

export class RegulatoryComplainceDto implements IRegulatoryComplainceDto {
    fatcaReportingStatusType?: string | undefined;
    fatcaTinType?: string | undefined;
    fatcaTinNumber?: string | undefined;
    crsReportingStatusType?: string | undefined;
    isUsCitizen?: boolean;
    isUsResident?: boolean;
    isCanadianTaxResident?: boolean;
    isTaxResidentOutsideCanUsa?: boolean;
    crsCountry?: string | undefined;
    crsTinNumber?: string | undefined;
    noTinReasonType?: string | undefined;
    reasonIfOther?: string | undefined;
    crsCountry2?: string | undefined;
    crsTinNumber2?: string | undefined;
    noTinReasonType2?: string | undefined;
    reasonIfOther2?: string | undefined;
    liveInCanada?: boolean;
    workInCanada?: boolean;
    financialRelationshipType?: string | undefined;
    meridianRelationshipType?: string | undefined;
    isPoliticallyExposed?: boolean;
    positionOfOfficeHeld?: string | undefined;
    nameOfGovernmentInstitution?: string | undefined;
    governmentLevelType?: string | undefined;
    countryPositionOfOfficeHeld?: string | undefined;
    isFamilyMemberPoliticallyExposed?: boolean;
    exposedFamilyType?: string | undefined;
    familyPositionOfOfficeHeld?: string | undefined;
    familyNameOfGovernmentInstitution?: string | undefined;
    familyGovernmentLevelType?: string | undefined;
    familyCountryPositionOfOfficeHeld?: string | undefined;
    ownerOperator?: boolean;

    constructor(data?: IRegulatoryComplainceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fatcaReportingStatusType = _data["fatcaReportingStatusType"];
            this.fatcaTinType = _data["fatcaTinType"];
            this.fatcaTinNumber = _data["fatcaTinNumber"];
            this.crsReportingStatusType = _data["crsReportingStatusType"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.isUsResident = _data["isUsResident"];
            this.isCanadianTaxResident = _data["isCanadianTaxResident"];
            this.isTaxResidentOutsideCanUsa = _data["isTaxResidentOutsideCanUsa"];
            this.crsCountry = _data["crsCountry"];
            this.crsTinNumber = _data["crsTinNumber"];
            this.noTinReasonType = _data["noTinReasonType"];
            this.reasonIfOther = _data["reasonIfOther"];
            this.crsCountry2 = _data["crsCountry2"];
            this.crsTinNumber2 = _data["crsTinNumber2"];
            this.noTinReasonType2 = _data["noTinReasonType2"];
            this.reasonIfOther2 = _data["reasonIfOther2"];
            this.liveInCanada = _data["liveInCanada"];
            this.workInCanada = _data["workInCanada"];
            this.financialRelationshipType = _data["financialRelationshipType"];
            this.meridianRelationshipType = _data["meridianRelationshipType"];
            this.isPoliticallyExposed = _data["isPoliticallyExposed"];
            this.positionOfOfficeHeld = _data["positionOfOfficeHeld"];
            this.nameOfGovernmentInstitution = _data["nameOfGovernmentInstitution"];
            this.governmentLevelType = _data["governmentLevelType"];
            this.countryPositionOfOfficeHeld = _data["countryPositionOfOfficeHeld"];
            this.isFamilyMemberPoliticallyExposed = _data["isFamilyMemberPoliticallyExposed"];
            this.exposedFamilyType = _data["exposedFamilyType"];
            this.familyPositionOfOfficeHeld = _data["familyPositionOfOfficeHeld"];
            this.familyNameOfGovernmentInstitution = _data["familyNameOfGovernmentInstitution"];
            this.familyGovernmentLevelType = _data["familyGovernmentLevelType"];
            this.familyCountryPositionOfOfficeHeld = _data["familyCountryPositionOfOfficeHeld"];
            this.ownerOperator = _data["ownerOperator"];
        }
    }

    static fromJS(data: any): RegulatoryComplainceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatoryComplainceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fatcaReportingStatusType"] = this.fatcaReportingStatusType;
        data["fatcaTinType"] = this.fatcaTinType;
        data["fatcaTinNumber"] = this.fatcaTinNumber;
        data["crsReportingStatusType"] = this.crsReportingStatusType;
        data["isUsCitizen"] = this.isUsCitizen;
        data["isUsResident"] = this.isUsResident;
        data["isCanadianTaxResident"] = this.isCanadianTaxResident;
        data["isTaxResidentOutsideCanUsa"] = this.isTaxResidentOutsideCanUsa;
        data["crsCountry"] = this.crsCountry;
        data["crsTinNumber"] = this.crsTinNumber;
        data["noTinReasonType"] = this.noTinReasonType;
        data["reasonIfOther"] = this.reasonIfOther;
        data["crsCountry2"] = this.crsCountry2;
        data["crsTinNumber2"] = this.crsTinNumber2;
        data["noTinReasonType2"] = this.noTinReasonType2;
        data["reasonIfOther2"] = this.reasonIfOther2;
        data["liveInCanada"] = this.liveInCanada;
        data["workInCanada"] = this.workInCanada;
        data["financialRelationshipType"] = this.financialRelationshipType;
        data["meridianRelationshipType"] = this.meridianRelationshipType;
        data["isPoliticallyExposed"] = this.isPoliticallyExposed;
        data["positionOfOfficeHeld"] = this.positionOfOfficeHeld;
        data["nameOfGovernmentInstitution"] = this.nameOfGovernmentInstitution;
        data["governmentLevelType"] = this.governmentLevelType;
        data["countryPositionOfOfficeHeld"] = this.countryPositionOfOfficeHeld;
        data["isFamilyMemberPoliticallyExposed"] = this.isFamilyMemberPoliticallyExposed;
        data["exposedFamilyType"] = this.exposedFamilyType;
        data["familyPositionOfOfficeHeld"] = this.familyPositionOfOfficeHeld;
        data["familyNameOfGovernmentInstitution"] = this.familyNameOfGovernmentInstitution;
        data["familyGovernmentLevelType"] = this.familyGovernmentLevelType;
        data["familyCountryPositionOfOfficeHeld"] = this.familyCountryPositionOfOfficeHeld;
        data["ownerOperator"] = this.ownerOperator;
        return data;
    }
}

export interface IRegulatoryComplainceDto {
    fatcaReportingStatusType?: string | undefined;
    fatcaTinType?: string | undefined;
    fatcaTinNumber?: string | undefined;
    crsReportingStatusType?: string | undefined;
    isUsCitizen?: boolean;
    isUsResident?: boolean;
    isCanadianTaxResident?: boolean;
    isTaxResidentOutsideCanUsa?: boolean;
    crsCountry?: string | undefined;
    crsTinNumber?: string | undefined;
    noTinReasonType?: string | undefined;
    reasonIfOther?: string | undefined;
    crsCountry2?: string | undefined;
    crsTinNumber2?: string | undefined;
    noTinReasonType2?: string | undefined;
    reasonIfOther2?: string | undefined;
    liveInCanada?: boolean;
    workInCanada?: boolean;
    financialRelationshipType?: string | undefined;
    meridianRelationshipType?: string | undefined;
    isPoliticallyExposed?: boolean;
    positionOfOfficeHeld?: string | undefined;
    nameOfGovernmentInstitution?: string | undefined;
    governmentLevelType?: string | undefined;
    countryPositionOfOfficeHeld?: string | undefined;
    isFamilyMemberPoliticallyExposed?: boolean;
    exposedFamilyType?: string | undefined;
    familyPositionOfOfficeHeld?: string | undefined;
    familyNameOfGovernmentInstitution?: string | undefined;
    familyGovernmentLevelType?: string | undefined;
    familyCountryPositionOfOfficeHeld?: string | undefined;
    ownerOperator?: boolean;
}

export class CreateDealDto implements ICreateDealDto {
    applicants?: DealApplicantDto[] | undefined;
    applications?: MortgageApplicationForDisplayDto[] | undefined;
    assets?: DealAssetsDto;
    id?: number;
    goal?: string | undefined;
    channel?: string | undefined;
    status?: string | undefined;
    digitalNextStep?: string | undefined;
    statusChangedDate?: dayjs.Dayjs;

    constructor(data?: ICreateDealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(DealApplicantDto.fromJS(item));
            }
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(MortgageApplicationForDisplayDto.fromJS(item));
            }
            this.assets = _data["assets"] ? DealAssetsDto.fromJS(_data["assets"]) : <any>undefined;
            this.id = _data["id"];
            this.goal = _data["goal"];
            this.channel = _data["channel"];
            this.status = _data["status"];
            this.digitalNextStep = _data["digitalNextStep"];
            this.statusChangedDate = _data["statusChangedDate"] ? dayjs(_data["statusChangedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateDealDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item.toJSON());
        }
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        data["assets"] = this.assets ? this.assets.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["goal"] = this.goal;
        data["channel"] = this.channel;
        data["status"] = this.status;
        data["digitalNextStep"] = this.digitalNextStep;
        data["statusChangedDate"] = this.statusChangedDate ? this.statusChangedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateDealDto {
    applicants?: DealApplicantDto[] | undefined;
    applications?: MortgageApplicationForDisplayDto[] | undefined;
    assets?: DealAssetsDto;
    id?: number;
    goal?: string | undefined;
    channel?: string | undefined;
    status?: string | undefined;
    digitalNextStep?: string | undefined;
    statusChangedDate?: dayjs.Dayjs;
}

export class DealApplicantDto implements IDealApplicantDto {
    applicantId?: number;
    name?: string | undefined;
    creditScore?: number;
    relationship?: string | undefined;
    primary?: boolean;
    connectedParty?: boolean;
    isStaff?: boolean;
    isRestrictedParty?: boolean;
    isOnboarded?: boolean;
    applicantConsent?: ApplicantConsentDto;

    constructor(data?: IDealApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.name = _data["name"];
            this.creditScore = _data["creditScore"];
            this.relationship = _data["relationship"];
            this.primary = _data["primary"];
            this.connectedParty = _data["connectedParty"];
            this.isStaff = _data["isStaff"];
            this.isRestrictedParty = _data["isRestrictedParty"];
            this.isOnboarded = _data["isOnboarded"];
            this.applicantConsent = _data["applicantConsent"] ? ApplicantConsentDto.fromJS(_data["applicantConsent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DealApplicantDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["name"] = this.name;
        data["creditScore"] = this.creditScore;
        data["relationship"] = this.relationship;
        data["primary"] = this.primary;
        data["connectedParty"] = this.connectedParty;
        data["isStaff"] = this.isStaff;
        data["isRestrictedParty"] = this.isRestrictedParty;
        data["isOnboarded"] = this.isOnboarded;
        data["applicantConsent"] = this.applicantConsent ? this.applicantConsent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDealApplicantDto {
    applicantId?: number;
    name?: string | undefined;
    creditScore?: number;
    relationship?: string | undefined;
    primary?: boolean;
    connectedParty?: boolean;
    isStaff?: boolean;
    isRestrictedParty?: boolean;
    isOnboarded?: boolean;
    applicantConsent?: ApplicantConsentDto;
}

export class DealApplicationDto implements IDealApplicationDto {
    applicationId?: number;
    applicationType?: string | undefined;
    purpose?: string | undefined;
    security?: string | undefined;

    constructor(data?: IDealApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationType = _data["applicationType"];
            this.purpose = _data["purpose"];
            this.security = _data["security"];
        }
    }

    static fromJS(data: any): DealApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationType"] = this.applicationType;
        data["purpose"] = this.purpose;
        data["security"] = this.security;
        return data;
    }
}

export interface IDealApplicationDto {
    applicationId?: number;
    applicationType?: string | undefined;
    purpose?: string | undefined;
    security?: string | undefined;
}

export class DealAssetsDto implements IDealAssetsDto {
    nonRegistered?: FinancialAssetDto[] | undefined;
    registered?: FinancialAssetDto[] | undefined;
    realEstate?: RealEstateDto[] | undefined;
    vehicle?: VehicleDto[] | undefined;
    lifeInsurance?: LifeInsuranceDto[] | undefined;
    other?: AssetDto[] | undefined;
    downPayment?: AssetDto[] | undefined;

    constructor(data?: IDealAssetsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nonRegistered"])) {
                this.nonRegistered = [] as any;
                for (let item of _data["nonRegistered"])
                    this.nonRegistered!.push(FinancialAssetDto.fromJS(item));
            }
            if (Array.isArray(_data["registered"])) {
                this.registered = [] as any;
                for (let item of _data["registered"])
                    this.registered!.push(FinancialAssetDto.fromJS(item));
            }
            if (Array.isArray(_data["realEstate"])) {
                this.realEstate = [] as any;
                for (let item of _data["realEstate"])
                    this.realEstate!.push(RealEstateDto.fromJS(item));
            }
            if (Array.isArray(_data["vehicle"])) {
                this.vehicle = [] as any;
                for (let item of _data["vehicle"])
                    this.vehicle!.push(VehicleDto.fromJS(item));
            }
            if (Array.isArray(_data["lifeInsurance"])) {
                this.lifeInsurance = [] as any;
                for (let item of _data["lifeInsurance"])
                    this.lifeInsurance!.push(LifeInsuranceDto.fromJS(item));
            }
            if (Array.isArray(_data["other"])) {
                this.other = [] as any;
                for (let item of _data["other"])
                    this.other!.push(AssetDto.fromJS(item));
            }
            if (Array.isArray(_data["downPayment"])) {
                this.downPayment = [] as any;
                for (let item of _data["downPayment"])
                    this.downPayment!.push(AssetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DealAssetsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealAssetsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nonRegistered)) {
            data["nonRegistered"] = [];
            for (let item of this.nonRegistered)
                data["nonRegistered"].push(item.toJSON());
        }
        if (Array.isArray(this.registered)) {
            data["registered"] = [];
            for (let item of this.registered)
                data["registered"].push(item.toJSON());
        }
        if (Array.isArray(this.realEstate)) {
            data["realEstate"] = [];
            for (let item of this.realEstate)
                data["realEstate"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicle)) {
            data["vehicle"] = [];
            for (let item of this.vehicle)
                data["vehicle"].push(item.toJSON());
        }
        if (Array.isArray(this.lifeInsurance)) {
            data["lifeInsurance"] = [];
            for (let item of this.lifeInsurance)
                data["lifeInsurance"].push(item.toJSON());
        }
        if (Array.isArray(this.other)) {
            data["other"] = [];
            for (let item of this.other)
                data["other"].push(item.toJSON());
        }
        if (Array.isArray(this.downPayment)) {
            data["downPayment"] = [];
            for (let item of this.downPayment)
                data["downPayment"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDealAssetsDto {
    nonRegistered?: FinancialAssetDto[] | undefined;
    registered?: FinancialAssetDto[] | undefined;
    realEstate?: RealEstateDto[] | undefined;
    vehicle?: VehicleDto[] | undefined;
    lifeInsurance?: LifeInsuranceDto[] | undefined;
    other?: AssetDto[] | undefined;
    downPayment?: AssetDto[] | undefined;
}

export class DealDto implements IDealDto {
    id?: number;
    goal?: string | undefined;
    channel?: string | undefined;
    status?: string | undefined;
    digitalNextStep?: string | undefined;
    statusChangedDate?: dayjs.Dayjs;

    constructor(data?: IDealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.goal = _data["goal"];
            this.channel = _data["channel"];
            this.status = _data["status"];
            this.digitalNextStep = _data["digitalNextStep"];
            this.statusChangedDate = _data["statusChangedDate"] ? dayjs(_data["statusChangedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DealDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["goal"] = this.goal;
        data["channel"] = this.channel;
        data["status"] = this.status;
        data["digitalNextStep"] = this.digitalNextStep;
        data["statusChangedDate"] = this.statusChangedDate ? this.statusChangedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDealDto {
    id?: number;
    goal?: string | undefined;
    channel?: string | undefined;
    status?: string | undefined;
    digitalNextStep?: string | undefined;
    statusChangedDate?: dayjs.Dayjs;
}

export class DealExpensesDto implements IDealExpensesDto {
    property?: PropertyExpenseDto[] | undefined;

    constructor(data?: IDealExpensesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["property"])) {
                this.property = [] as any;
                for (let item of _data["property"])
                    this.property!.push(PropertyExpenseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DealExpensesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealExpensesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.property)) {
            data["property"] = [];
            for (let item of this.property)
                data["property"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDealExpensesDto {
    property?: PropertyExpenseDto[] | undefined;
}

export class DealForCreationDto implements IDealForCreationDto {
    purpose?: string | undefined;

    constructor(data?: IDealForCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purpose = _data["purpose"];
        }
    }

    static fromJS(data: any): DealForCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealForCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purpose"] = this.purpose;
        return data;
    }
}

export interface IDealForCreationDto {
    purpose?: string | undefined;
}

export class FundmoreFields implements IFundmoreFields {
    fm_application_id?: string | undefined;
    fm_applicant_id?: string | undefined;
    mcu_applicant_id?: string | undefined;
    deal_id?: number | undefined;
    cust_no?: number | undefined;
    first_name?: string | undefined;
    last_name?: string | undefined;
    dob?: dayjs.Dayjs | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IFundmoreFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fm_application_id = _data["fm_application_id"];
            this.fm_applicant_id = _data["fm_applicant_id"];
            this.mcu_applicant_id = _data["mcu_applicant_id"];
            this.deal_id = _data["deal_id"];
            this.cust_no = _data["cust_no"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.dob = _data["dob"] ? dayjs(_data["dob"].toString()) : <any>undefined;
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): FundmoreFields {
        data = typeof data === 'object' ? data : {};
        let result = new FundmoreFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fm_application_id"] = this.fm_application_id;
        data["fm_applicant_id"] = this.fm_applicant_id;
        data["mcu_applicant_id"] = this.mcu_applicant_id;
        data["deal_id"] = this.deal_id;
        data["cust_no"] = this.cust_no;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface IFundmoreFields {
    fm_application_id?: string | undefined;
    fm_applicant_id?: string | undefined;
    mcu_applicant_id?: string | undefined;
    deal_id?: number | undefined;
    cust_no?: number | undefined;
    first_name?: string | undefined;
    last_name?: string | undefined;
    dob?: dayjs.Dayjs | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class FundmoreRequestDto implements IFundmoreRequestDto {
    issuer?: string | undefined;
    nameID?: string | undefined;
    email?: string | undefined;
    attributes?: FundmoreFields;

    constructor(data?: IFundmoreRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuer = _data["issuer"];
            this.nameID = _data["nameID"];
            this.email = _data["email"];
            this.attributes = _data["attributes"] ? FundmoreFields.fromJS(_data["attributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FundmoreRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FundmoreRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer;
        data["nameID"] = this.nameID;
        data["email"] = this.email;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFundmoreRequestDto {
    issuer?: string | undefined;
    nameID?: string | undefined;
    email?: string | undefined;
    attributes?: FundmoreFields;
}

export class MortgageDealDto implements IMortgageDealDto {
    applicants?: DealApplicantDto[] | undefined;
    applications?: DealApplicationDto[] | undefined;
    assets?: DealAssetsDto;
    expenses?: DealExpensesDto;
    id?: number;
    goal?: string | undefined;
    channel?: string | undefined;
    status?: string | undefined;
    digitalNextStep?: string | undefined;
    statusChangedDate?: dayjs.Dayjs;

    constructor(data?: IMortgageDealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(DealApplicantDto.fromJS(item));
            }
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(DealApplicationDto.fromJS(item));
            }
            this.assets = _data["assets"] ? DealAssetsDto.fromJS(_data["assets"]) : <any>undefined;
            this.expenses = _data["expenses"] ? DealExpensesDto.fromJS(_data["expenses"]) : <any>undefined;
            this.id = _data["id"];
            this.goal = _data["goal"];
            this.channel = _data["channel"];
            this.status = _data["status"];
            this.digitalNextStep = _data["digitalNextStep"];
            this.statusChangedDate = _data["statusChangedDate"] ? dayjs(_data["statusChangedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MortgageDealDto {
        data = typeof data === 'object' ? data : {};
        let result = new MortgageDealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item.toJSON());
        }
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        data["assets"] = this.assets ? this.assets.toJSON() : <any>undefined;
        data["expenses"] = this.expenses ? this.expenses.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["goal"] = this.goal;
        data["channel"] = this.channel;
        data["status"] = this.status;
        data["digitalNextStep"] = this.digitalNextStep;
        data["statusChangedDate"] = this.statusChangedDate ? this.statusChangedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMortgageDealDto {
    applicants?: DealApplicantDto[] | undefined;
    applications?: DealApplicationDto[] | undefined;
    assets?: DealAssetsDto;
    expenses?: DealExpensesDto;
    id?: number;
    goal?: string | undefined;
    channel?: string | undefined;
    status?: string | undefined;
    digitalNextStep?: string | undefined;
    statusChangedDate?: dayjs.Dayjs;
}

export class EmploymentDto implements IEmploymentDto {
    id?: number;
    employmentType_Name?: string | undefined;
    employmentPositionType_Name?: string | undefined;
    jobTitle?: string | undefined;
    employer_Name?: string | undefined;
    employer_Phone?: string | undefined;
    employer_Address_StreetNumber?: string | undefined;
    employer_Address_StreetName?: string | undefined;
    employer_Address_StreetType?: string | undefined;
    employer_Address_StreetDirection?: string | undefined;
    employer_Address_UnitType?: string | undefined;
    employer_Address_UnitNumber?: string | undefined;
    employer_Address_City?: string | undefined;
    employer_Address_PostalCode?: string | undefined;
    employer_Address_Region?: string | undefined;
    employer_Address_Country?: string | undefined;
    monthsAtEmployment?: number;
    monthsInIndustry?: number;
    totalMonthsAtEmployment?: number;
    totalMonthsInIndustry?: number;
    fulltime?: boolean;
    previousEmployment?: boolean;
    onParentalLeave?: boolean;
    onOtherLeave?: boolean;
    leaveDescription?: string | undefined;
    returnToWorkDate?: dayjs.Dayjs | undefined;
    onProbation?: boolean;
    primary?: boolean;
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs | undefined;
    employer_Occupation_Industry?: string | undefined;
    employer_Occupation_Name?: string | undefined;
    ownership_OwnershipType_Name?: string | undefined;
    ownership_OwnershipPercentage?: number | undefined;
    ownership_BusinessType?: string | undefined;
    ownership_HasLendingWithMeridian?: boolean | undefined;
    familyOwned?: boolean;
    employmentIncomes?: EmploymentIncomeDto[] | undefined;

    constructor(data?: IEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employmentType_Name = _data["employmentType_Name"];
            this.employmentPositionType_Name = _data["employmentPositionType_Name"];
            this.jobTitle = _data["jobTitle"];
            this.employer_Name = _data["employer_Name"];
            this.employer_Phone = _data["employer_Phone"];
            this.employer_Address_StreetNumber = _data["employer_Address_StreetNumber"];
            this.employer_Address_StreetName = _data["employer_Address_StreetName"];
            this.employer_Address_StreetType = _data["employer_Address_StreetType"];
            this.employer_Address_StreetDirection = _data["employer_Address_StreetDirection"];
            this.employer_Address_UnitType = _data["employer_Address_UnitType"];
            this.employer_Address_UnitNumber = _data["employer_Address_UnitNumber"];
            this.employer_Address_City = _data["employer_Address_City"];
            this.employer_Address_PostalCode = _data["employer_Address_PostalCode"];
            this.employer_Address_Region = _data["employer_Address_Region"];
            this.employer_Address_Country = _data["employer_Address_Country"];
            this.monthsAtEmployment = _data["monthsAtEmployment"];
            this.monthsInIndustry = _data["monthsInIndustry"];
            this.totalMonthsAtEmployment = _data["totalMonthsAtEmployment"];
            this.totalMonthsInIndustry = _data["totalMonthsInIndustry"];
            this.fulltime = _data["fulltime"];
            this.previousEmployment = _data["previousEmployment"];
            this.onParentalLeave = _data["onParentalLeave"];
            this.onOtherLeave = _data["onOtherLeave"];
            this.leaveDescription = _data["leaveDescription"];
            this.returnToWorkDate = _data["returnToWorkDate"] ? dayjs(_data["returnToWorkDate"].toString()) : <any>undefined;
            this.onProbation = _data["onProbation"];
            this.primary = _data["primary"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : <any>undefined;
            this.employer_Occupation_Industry = _data["employer_Occupation_Industry"];
            this.employer_Occupation_Name = _data["employer_Occupation_Name"];
            this.ownership_OwnershipType_Name = _data["ownership_OwnershipType_Name"];
            this.ownership_OwnershipPercentage = _data["ownership_OwnershipPercentage"];
            this.ownership_BusinessType = _data["ownership_BusinessType"];
            this.ownership_HasLendingWithMeridian = _data["ownership_HasLendingWithMeridian"];
            this.familyOwned = _data["familyOwned"];
            if (Array.isArray(_data["employmentIncomes"])) {
                this.employmentIncomes = [] as any;
                for (let item of _data["employmentIncomes"])
                    this.employmentIncomes!.push(EmploymentIncomeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employmentType_Name"] = this.employmentType_Name;
        data["employmentPositionType_Name"] = this.employmentPositionType_Name;
        data["jobTitle"] = this.jobTitle;
        data["employer_Name"] = this.employer_Name;
        data["employer_Phone"] = this.employer_Phone;
        data["employer_Address_StreetNumber"] = this.employer_Address_StreetNumber;
        data["employer_Address_StreetName"] = this.employer_Address_StreetName;
        data["employer_Address_StreetType"] = this.employer_Address_StreetType;
        data["employer_Address_StreetDirection"] = this.employer_Address_StreetDirection;
        data["employer_Address_UnitType"] = this.employer_Address_UnitType;
        data["employer_Address_UnitNumber"] = this.employer_Address_UnitNumber;
        data["employer_Address_City"] = this.employer_Address_City;
        data["employer_Address_PostalCode"] = this.employer_Address_PostalCode;
        data["employer_Address_Region"] = this.employer_Address_Region;
        data["employer_Address_Country"] = this.employer_Address_Country;
        data["monthsAtEmployment"] = this.monthsAtEmployment;
        data["monthsInIndustry"] = this.monthsInIndustry;
        data["totalMonthsAtEmployment"] = this.totalMonthsAtEmployment;
        data["totalMonthsInIndustry"] = this.totalMonthsInIndustry;
        data["fulltime"] = this.fulltime;
        data["previousEmployment"] = this.previousEmployment;
        data["onParentalLeave"] = this.onParentalLeave;
        data["onOtherLeave"] = this.onOtherLeave;
        data["leaveDescription"] = this.leaveDescription;
        data["returnToWorkDate"] = this.returnToWorkDate ? this.returnToWorkDate.toISOString() : <any>undefined;
        data["onProbation"] = this.onProbation;
        data["primary"] = this.primary;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["employer_Occupation_Industry"] = this.employer_Occupation_Industry;
        data["employer_Occupation_Name"] = this.employer_Occupation_Name;
        data["ownership_OwnershipType_Name"] = this.ownership_OwnershipType_Name;
        data["ownership_OwnershipPercentage"] = this.ownership_OwnershipPercentage;
        data["ownership_BusinessType"] = this.ownership_BusinessType;
        data["ownership_HasLendingWithMeridian"] = this.ownership_HasLendingWithMeridian;
        data["familyOwned"] = this.familyOwned;
        if (Array.isArray(this.employmentIncomes)) {
            data["employmentIncomes"] = [];
            for (let item of this.employmentIncomes)
                data["employmentIncomes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmploymentDto {
    id?: number;
    employmentType_Name?: string | undefined;
    employmentPositionType_Name?: string | undefined;
    jobTitle?: string | undefined;
    employer_Name?: string | undefined;
    employer_Phone?: string | undefined;
    employer_Address_StreetNumber?: string | undefined;
    employer_Address_StreetName?: string | undefined;
    employer_Address_StreetType?: string | undefined;
    employer_Address_StreetDirection?: string | undefined;
    employer_Address_UnitType?: string | undefined;
    employer_Address_UnitNumber?: string | undefined;
    employer_Address_City?: string | undefined;
    employer_Address_PostalCode?: string | undefined;
    employer_Address_Region?: string | undefined;
    employer_Address_Country?: string | undefined;
    monthsAtEmployment?: number;
    monthsInIndustry?: number;
    totalMonthsAtEmployment?: number;
    totalMonthsInIndustry?: number;
    fulltime?: boolean;
    previousEmployment?: boolean;
    onParentalLeave?: boolean;
    onOtherLeave?: boolean;
    leaveDescription?: string | undefined;
    returnToWorkDate?: dayjs.Dayjs | undefined;
    onProbation?: boolean;
    primary?: boolean;
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs | undefined;
    employer_Occupation_Industry?: string | undefined;
    employer_Occupation_Name?: string | undefined;
    ownership_OwnershipType_Name?: string | undefined;
    ownership_OwnershipPercentage?: number | undefined;
    ownership_BusinessType?: string | undefined;
    ownership_HasLendingWithMeridian?: boolean | undefined;
    familyOwned?: boolean;
    employmentIncomes?: EmploymentIncomeDto[] | undefined;
}

export class EmploymentForManipulationDto implements IEmploymentForManipulationDto {
    id?: number;
    employmentType_Name?: string | undefined;
    employmentPositionType_Name?: string | undefined;
    jobTitle?: string | undefined;
    employer_Name?: string | undefined;
    employer_Phone?: string | undefined;
    employer_Address_StreetNumber?: string | undefined;
    employer_Address_StreetName?: string | undefined;
    employer_Address_StreetType?: string | undefined;
    employer_Address_StreetDirection?: string | undefined;
    employer_Address_UnitType?: string | undefined;
    employer_Address_UnitNumber?: string | undefined;
    employer_Address_City?: string | undefined;
    employer_Address_PostalCode?: string | undefined;
    employer_Address_Region?: string | undefined;
    employer_Address_Country?: string | undefined;
    monthsAtEmployment?: number;
    monthsInIndustry?: number;
    totalMonthsAtEmployment?: number;
    totalMonthsInIndustry?: number;
    fulltime?: boolean;
    previousEmployment?: boolean;
    onParentalLeave?: boolean;
    onOtherLeave?: boolean;
    leaveDescription?: string | undefined;
    returnToWorkDate?: dayjs.Dayjs | undefined;
    onProbation?: boolean;
    primary?: boolean;
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs | undefined;
    employer_Occupation_Industry?: string | undefined;
    employer_Occupation_Name?: string | undefined;
    ownership_OwnershipType_Name?: string | undefined;
    ownership_OwnershipPercentage?: number | undefined;
    ownership_BusinessType?: string | undefined;
    ownership_HasLendingWithMeridian?: boolean | undefined;
    familyOwned?: boolean;
    employmentIncomes?: EmploymentIncomeDto[] | undefined;

    constructor(data?: IEmploymentForManipulationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employmentType_Name = _data["employmentType_Name"];
            this.employmentPositionType_Name = _data["employmentPositionType_Name"];
            this.jobTitle = _data["jobTitle"];
            this.employer_Name = _data["employer_Name"];
            this.employer_Phone = _data["employer_Phone"];
            this.employer_Address_StreetNumber = _data["employer_Address_StreetNumber"];
            this.employer_Address_StreetName = _data["employer_Address_StreetName"];
            this.employer_Address_StreetType = _data["employer_Address_StreetType"];
            this.employer_Address_StreetDirection = _data["employer_Address_StreetDirection"];
            this.employer_Address_UnitType = _data["employer_Address_UnitType"];
            this.employer_Address_UnitNumber = _data["employer_Address_UnitNumber"];
            this.employer_Address_City = _data["employer_Address_City"];
            this.employer_Address_PostalCode = _data["employer_Address_PostalCode"];
            this.employer_Address_Region = _data["employer_Address_Region"];
            this.employer_Address_Country = _data["employer_Address_Country"];
            this.monthsAtEmployment = _data["monthsAtEmployment"];
            this.monthsInIndustry = _data["monthsInIndustry"];
            this.totalMonthsAtEmployment = _data["totalMonthsAtEmployment"];
            this.totalMonthsInIndustry = _data["totalMonthsInIndustry"];
            this.fulltime = _data["fulltime"];
            this.previousEmployment = _data["previousEmployment"];
            this.onParentalLeave = _data["onParentalLeave"];
            this.onOtherLeave = _data["onOtherLeave"];
            this.leaveDescription = _data["leaveDescription"];
            this.returnToWorkDate = _data["returnToWorkDate"] ? dayjs(_data["returnToWorkDate"].toString()) : <any>undefined;
            this.onProbation = _data["onProbation"];
            this.primary = _data["primary"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : <any>undefined;
            this.employer_Occupation_Industry = _data["employer_Occupation_Industry"];
            this.employer_Occupation_Name = _data["employer_Occupation_Name"];
            this.ownership_OwnershipType_Name = _data["ownership_OwnershipType_Name"];
            this.ownership_OwnershipPercentage = _data["ownership_OwnershipPercentage"];
            this.ownership_BusinessType = _data["ownership_BusinessType"];
            this.ownership_HasLendingWithMeridian = _data["ownership_HasLendingWithMeridian"];
            this.familyOwned = _data["familyOwned"];
            if (Array.isArray(_data["employmentIncomes"])) {
                this.employmentIncomes = [] as any;
                for (let item of _data["employmentIncomes"])
                    this.employmentIncomes!.push(EmploymentIncomeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmploymentForManipulationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentForManipulationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employmentType_Name"] = this.employmentType_Name;
        data["employmentPositionType_Name"] = this.employmentPositionType_Name;
        data["jobTitle"] = this.jobTitle;
        data["employer_Name"] = this.employer_Name;
        data["employer_Phone"] = this.employer_Phone;
        data["employer_Address_StreetNumber"] = this.employer_Address_StreetNumber;
        data["employer_Address_StreetName"] = this.employer_Address_StreetName;
        data["employer_Address_StreetType"] = this.employer_Address_StreetType;
        data["employer_Address_StreetDirection"] = this.employer_Address_StreetDirection;
        data["employer_Address_UnitType"] = this.employer_Address_UnitType;
        data["employer_Address_UnitNumber"] = this.employer_Address_UnitNumber;
        data["employer_Address_City"] = this.employer_Address_City;
        data["employer_Address_PostalCode"] = this.employer_Address_PostalCode;
        data["employer_Address_Region"] = this.employer_Address_Region;
        data["employer_Address_Country"] = this.employer_Address_Country;
        data["monthsAtEmployment"] = this.monthsAtEmployment;
        data["monthsInIndustry"] = this.monthsInIndustry;
        data["totalMonthsAtEmployment"] = this.totalMonthsAtEmployment;
        data["totalMonthsInIndustry"] = this.totalMonthsInIndustry;
        data["fulltime"] = this.fulltime;
        data["previousEmployment"] = this.previousEmployment;
        data["onParentalLeave"] = this.onParentalLeave;
        data["onOtherLeave"] = this.onOtherLeave;
        data["leaveDescription"] = this.leaveDescription;
        data["returnToWorkDate"] = this.returnToWorkDate ? this.returnToWorkDate.toISOString() : <any>undefined;
        data["onProbation"] = this.onProbation;
        data["primary"] = this.primary;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["employer_Occupation_Industry"] = this.employer_Occupation_Industry;
        data["employer_Occupation_Name"] = this.employer_Occupation_Name;
        data["ownership_OwnershipType_Name"] = this.ownership_OwnershipType_Name;
        data["ownership_OwnershipPercentage"] = this.ownership_OwnershipPercentage;
        data["ownership_BusinessType"] = this.ownership_BusinessType;
        data["ownership_HasLendingWithMeridian"] = this.ownership_HasLendingWithMeridian;
        data["familyOwned"] = this.familyOwned;
        if (Array.isArray(this.employmentIncomes)) {
            data["employmentIncomes"] = [];
            for (let item of this.employmentIncomes)
                data["employmentIncomes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmploymentForManipulationDto {
    id?: number;
    employmentType_Name?: string | undefined;
    employmentPositionType_Name?: string | undefined;
    jobTitle?: string | undefined;
    employer_Name?: string | undefined;
    employer_Phone?: string | undefined;
    employer_Address_StreetNumber?: string | undefined;
    employer_Address_StreetName?: string | undefined;
    employer_Address_StreetType?: string | undefined;
    employer_Address_StreetDirection?: string | undefined;
    employer_Address_UnitType?: string | undefined;
    employer_Address_UnitNumber?: string | undefined;
    employer_Address_City?: string | undefined;
    employer_Address_PostalCode?: string | undefined;
    employer_Address_Region?: string | undefined;
    employer_Address_Country?: string | undefined;
    monthsAtEmployment?: number;
    monthsInIndustry?: number;
    totalMonthsAtEmployment?: number;
    totalMonthsInIndustry?: number;
    fulltime?: boolean;
    previousEmployment?: boolean;
    onParentalLeave?: boolean;
    onOtherLeave?: boolean;
    leaveDescription?: string | undefined;
    returnToWorkDate?: dayjs.Dayjs | undefined;
    onProbation?: boolean;
    primary?: boolean;
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs | undefined;
    employer_Occupation_Industry?: string | undefined;
    employer_Occupation_Name?: string | undefined;
    ownership_OwnershipType_Name?: string | undefined;
    ownership_OwnershipPercentage?: number | undefined;
    ownership_BusinessType?: string | undefined;
    ownership_HasLendingWithMeridian?: boolean | undefined;
    familyOwned?: boolean;
    employmentIncomes?: EmploymentIncomeDto[] | undefined;
}

export class EmploymentIncomeDto implements IEmploymentIncomeDto {
    id?: number | undefined;
    employmentId?: number | undefined;
    hoursPerFrequency?: number | undefined;
    guaranteedHours?: boolean | undefined;
    endDate?: dayjs.Dayjs | undefined;
    incomeCategoryType_Name?: string | undefined;
    incomeType_Name?: string | undefined;
    applicantId?: number;
    dealId?: number;
    currencyType_Name?: string | undefined;
    frequencyType_Name?: string | undefined;
    amountPerFrequency?: number;
    description?: string | undefined;
    country?: string | undefined;
    sinceDate?: dayjs.Dayjs | undefined;
    conversionRate?: number | undefined;
    conversionRateDate?: dayjs.Dayjs | undefined;
    primaryIncomeSource?: boolean | undefined;

    constructor(data?: IEmploymentIncomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employmentId = _data["employmentId"];
            this.hoursPerFrequency = _data["hoursPerFrequency"];
            this.guaranteedHours = _data["guaranteedHours"];
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : <any>undefined;
            this.incomeCategoryType_Name = _data["incomeCategoryType_Name"];
            this.incomeType_Name = _data["incomeType_Name"];
            this.applicantId = _data["applicantId"];
            this.dealId = _data["dealId"];
            this.currencyType_Name = _data["currencyType_Name"];
            this.frequencyType_Name = _data["frequencyType_Name"];
            this.amountPerFrequency = _data["amountPerFrequency"];
            this.description = _data["description"];
            this.country = _data["country"];
            this.sinceDate = _data["sinceDate"] ? dayjs(_data["sinceDate"].toString()) : <any>undefined;
            this.conversionRate = _data["conversionRate"];
            this.conversionRateDate = _data["conversionRateDate"] ? dayjs(_data["conversionRateDate"].toString()) : <any>undefined;
            this.primaryIncomeSource = _data["primaryIncomeSource"];
        }
    }

    static fromJS(data: any): EmploymentIncomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentIncomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employmentId"] = this.employmentId;
        data["hoursPerFrequency"] = this.hoursPerFrequency;
        data["guaranteedHours"] = this.guaranteedHours;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["incomeCategoryType_Name"] = this.incomeCategoryType_Name;
        data["incomeType_Name"] = this.incomeType_Name;
        data["applicantId"] = this.applicantId;
        data["dealId"] = this.dealId;
        data["currencyType_Name"] = this.currencyType_Name;
        data["frequencyType_Name"] = this.frequencyType_Name;
        data["amountPerFrequency"] = this.amountPerFrequency;
        data["description"] = this.description;
        data["country"] = this.country;
        data["sinceDate"] = this.sinceDate ? this.sinceDate.toISOString() : <any>undefined;
        data["conversionRate"] = this.conversionRate;
        data["conversionRateDate"] = this.conversionRateDate ? this.conversionRateDate.toISOString() : <any>undefined;
        data["primaryIncomeSource"] = this.primaryIncomeSource;
        return data;
    }
}

export interface IEmploymentIncomeDto {
    id?: number | undefined;
    employmentId?: number | undefined;
    hoursPerFrequency?: number | undefined;
    guaranteedHours?: boolean | undefined;
    endDate?: dayjs.Dayjs | undefined;
    incomeCategoryType_Name?: string | undefined;
    incomeType_Name?: string | undefined;
    applicantId?: number;
    dealId?: number;
    currencyType_Name?: string | undefined;
    frequencyType_Name?: string | undefined;
    amountPerFrequency?: number;
    description?: string | undefined;
    country?: string | undefined;
    sinceDate?: dayjs.Dayjs | undefined;
    conversionRate?: number | undefined;
    conversionRateDate?: dayjs.Dayjs | undefined;
    primaryIncomeSource?: boolean | undefined;
}

export class AssetDto implements IAssetDto {
    id?: number;
    assetCategoryType_Name?: string | undefined;
    assetType_Name?: string | undefined;
    origin_Name?: string | undefined;
    value?: number;
    description?: string | undefined;
    downPaymentValue?: number;
    applicants?: number[] | undefined;

    constructor(data?: IAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetCategoryType_Name = _data["assetCategoryType_Name"];
            this.assetType_Name = _data["assetType_Name"];
            this.origin_Name = _data["origin_Name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.downPaymentValue = _data["downPaymentValue"];
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetCategoryType_Name"] = this.assetCategoryType_Name;
        data["assetType_Name"] = this.assetType_Name;
        data["origin_Name"] = this.origin_Name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["downPaymentValue"] = this.downPaymentValue;
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item);
        }
        return data;
    }
}

export interface IAssetDto {
    id?: number;
    assetCategoryType_Name?: string | undefined;
    assetType_Name?: string | undefined;
    origin_Name?: string | undefined;
    value?: number;
    description?: string | undefined;
    downPaymentValue?: number;
    applicants?: number[] | undefined;
}

export class FinancialAssetDto implements IFinancialAssetDto {
    fiName?: string | undefined;
    fiNameOther?: string | undefined;
    id?: number;
    assetCategoryType_Name?: string | undefined;
    assetType_Name?: string | undefined;
    origin_Name?: string | undefined;
    value?: number;
    description?: string | undefined;
    downPaymentValue?: number;
    applicants?: number[] | undefined;

    constructor(data?: IFinancialAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fiName = _data["fiName"];
            this.fiNameOther = _data["fiNameOther"];
            this.id = _data["id"];
            this.assetCategoryType_Name = _data["assetCategoryType_Name"];
            this.assetType_Name = _data["assetType_Name"];
            this.origin_Name = _data["origin_Name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.downPaymentValue = _data["downPaymentValue"];
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(item);
            }
        }
    }

    static fromJS(data: any): FinancialAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiName"] = this.fiName;
        data["fiNameOther"] = this.fiNameOther;
        data["id"] = this.id;
        data["assetCategoryType_Name"] = this.assetCategoryType_Name;
        data["assetType_Name"] = this.assetType_Name;
        data["origin_Name"] = this.origin_Name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["downPaymentValue"] = this.downPaymentValue;
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item);
        }
        return data;
    }
}

export interface IFinancialAssetDto {
    fiName?: string | undefined;
    fiNameOther?: string | undefined;
    id?: number;
    assetCategoryType_Name?: string | undefined;
    assetType_Name?: string | undefined;
    origin_Name?: string | undefined;
    value?: number;
    description?: string | undefined;
    downPaymentValue?: number;
    applicants?: number[] | undefined;
}

export class LifeInsuranceDto implements ILifeInsuranceDto {
    cashSurrenderValue?: number;
    id?: number;
    assetCategoryType_Name?: string | undefined;
    assetType_Name?: string | undefined;
    origin_Name?: string | undefined;
    value?: number;
    description?: string | undefined;
    downPaymentValue?: number;
    applicants?: number[] | undefined;

    constructor(data?: ILifeInsuranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashSurrenderValue = _data["cashSurrenderValue"];
            this.id = _data["id"];
            this.assetCategoryType_Name = _data["assetCategoryType_Name"];
            this.assetType_Name = _data["assetType_Name"];
            this.origin_Name = _data["origin_Name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.downPaymentValue = _data["downPaymentValue"];
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(item);
            }
        }
    }

    static fromJS(data: any): LifeInsuranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifeInsuranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashSurrenderValue"] = this.cashSurrenderValue;
        data["id"] = this.id;
        data["assetCategoryType_Name"] = this.assetCategoryType_Name;
        data["assetType_Name"] = this.assetType_Name;
        data["origin_Name"] = this.origin_Name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["downPaymentValue"] = this.downPaymentValue;
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item);
        }
        return data;
    }
}

export interface ILifeInsuranceDto {
    cashSurrenderValue?: number;
    id?: number;
    assetCategoryType_Name?: string | undefined;
    assetType_Name?: string | undefined;
    origin_Name?: string | undefined;
    value?: number;
    description?: string | undefined;
    downPaymentValue?: number;
    applicants?: number[] | undefined;
}

export class RealEstateDto implements IRealEstateDto {
    occupancyType_Name?: string | undefined;
    propertyType_Name?: string | undefined;
    rentalComponent?: boolean;
    numberOfProperties?: number;
    assetAddress_StreetNumber?: string | undefined;
    assetAddress_StreetName?: string | undefined;
    assetAddress_StreetType?: string | undefined;
    assetAddress_StreetDirection?: string | undefined;
    assetAddress_UnitType?: string | undefined;
    assetAddress_UnitNumber?: string | undefined;
    assetAddress_City?: string | undefined;
    assetAddress_PostalCode?: string | undefined;
    assetAddress_Region?: string | undefined;
    assetAddress_Country?: string | undefined;
    origPurchasePrice?: number | undefined;
    origPurchaseDate?: dayjs.Dayjs | undefined;
    lot?: string | undefined;
    block?: string | undefined;
    plan?: string | undefined;
    section?: string | undefined;
    futureUsageType_Name?: string | undefined;
    hasPropertyBeenSold?: boolean | undefined;
    soldDate?: dayjs.Dayjs | undefined;
    rentalIncome?: number | undefined;
    id?: number;
    assetCategoryType_Name?: string | undefined;
    assetType_Name?: string | undefined;
    origin_Name?: string | undefined;
    value?: number;
    description?: string | undefined;
    downPaymentValue?: number;
    applicants?: number[] | undefined;

    constructor(data?: IRealEstateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.occupancyType_Name = _data["occupancyType_Name"];
            this.propertyType_Name = _data["propertyType_Name"];
            this.rentalComponent = _data["rentalComponent"];
            this.numberOfProperties = _data["numberOfProperties"];
            this.assetAddress_StreetNumber = _data["assetAddress_StreetNumber"];
            this.assetAddress_StreetName = _data["assetAddress_StreetName"];
            this.assetAddress_StreetType = _data["assetAddress_StreetType"];
            this.assetAddress_StreetDirection = _data["assetAddress_StreetDirection"];
            this.assetAddress_UnitType = _data["assetAddress_UnitType"];
            this.assetAddress_UnitNumber = _data["assetAddress_UnitNumber"];
            this.assetAddress_City = _data["assetAddress_City"];
            this.assetAddress_PostalCode = _data["assetAddress_PostalCode"];
            this.assetAddress_Region = _data["assetAddress_Region"];
            this.assetAddress_Country = _data["assetAddress_Country"];
            this.origPurchasePrice = _data["origPurchasePrice"];
            this.origPurchaseDate = _data["origPurchaseDate"] ? dayjs(_data["origPurchaseDate"].toString()) : <any>undefined;
            this.lot = _data["lot"];
            this.block = _data["block"];
            this.plan = _data["plan"];
            this.section = _data["section"];
            this.futureUsageType_Name = _data["futureUsageType_Name"];
            this.hasPropertyBeenSold = _data["hasPropertyBeenSold"];
            this.soldDate = _data["soldDate"] ? dayjs(_data["soldDate"].toString()) : <any>undefined;
            this.rentalIncome = _data["rentalIncome"];
            this.id = _data["id"];
            this.assetCategoryType_Name = _data["assetCategoryType_Name"];
            this.assetType_Name = _data["assetType_Name"];
            this.origin_Name = _data["origin_Name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.downPaymentValue = _data["downPaymentValue"];
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(item);
            }
        }
    }

    static fromJS(data: any): RealEstateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RealEstateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occupancyType_Name"] = this.occupancyType_Name;
        data["propertyType_Name"] = this.propertyType_Name;
        data["rentalComponent"] = this.rentalComponent;
        data["numberOfProperties"] = this.numberOfProperties;
        data["assetAddress_StreetNumber"] = this.assetAddress_StreetNumber;
        data["assetAddress_StreetName"] = this.assetAddress_StreetName;
        data["assetAddress_StreetType"] = this.assetAddress_StreetType;
        data["assetAddress_StreetDirection"] = this.assetAddress_StreetDirection;
        data["assetAddress_UnitType"] = this.assetAddress_UnitType;
        data["assetAddress_UnitNumber"] = this.assetAddress_UnitNumber;
        data["assetAddress_City"] = this.assetAddress_City;
        data["assetAddress_PostalCode"] = this.assetAddress_PostalCode;
        data["assetAddress_Region"] = this.assetAddress_Region;
        data["assetAddress_Country"] = this.assetAddress_Country;
        data["origPurchasePrice"] = this.origPurchasePrice;
        data["origPurchaseDate"] = this.origPurchaseDate ? this.origPurchaseDate.toISOString() : <any>undefined;
        data["lot"] = this.lot;
        data["block"] = this.block;
        data["plan"] = this.plan;
        data["section"] = this.section;
        data["futureUsageType_Name"] = this.futureUsageType_Name;
        data["hasPropertyBeenSold"] = this.hasPropertyBeenSold;
        data["soldDate"] = this.soldDate ? this.soldDate.toISOString() : <any>undefined;
        data["rentalIncome"] = this.rentalIncome;
        data["id"] = this.id;
        data["assetCategoryType_Name"] = this.assetCategoryType_Name;
        data["assetType_Name"] = this.assetType_Name;
        data["origin_Name"] = this.origin_Name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["downPaymentValue"] = this.downPaymentValue;
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item);
        }
        return data;
    }
}

export interface IRealEstateDto {
    occupancyType_Name?: string | undefined;
    propertyType_Name?: string | undefined;
    rentalComponent?: boolean;
    numberOfProperties?: number;
    assetAddress_StreetNumber?: string | undefined;
    assetAddress_StreetName?: string | undefined;
    assetAddress_StreetType?: string | undefined;
    assetAddress_StreetDirection?: string | undefined;
    assetAddress_UnitType?: string | undefined;
    assetAddress_UnitNumber?: string | undefined;
    assetAddress_City?: string | undefined;
    assetAddress_PostalCode?: string | undefined;
    assetAddress_Region?: string | undefined;
    assetAddress_Country?: string | undefined;
    origPurchasePrice?: number | undefined;
    origPurchaseDate?: dayjs.Dayjs | undefined;
    lot?: string | undefined;
    block?: string | undefined;
    plan?: string | undefined;
    section?: string | undefined;
    futureUsageType_Name?: string | undefined;
    hasPropertyBeenSold?: boolean | undefined;
    soldDate?: dayjs.Dayjs | undefined;
    rentalIncome?: number | undefined;
    id?: number;
    assetCategoryType_Name?: string | undefined;
    assetType_Name?: string | undefined;
    origin_Name?: string | undefined;
    value?: number;
    description?: string | undefined;
    downPaymentValue?: number;
    applicants?: number[] | undefined;
}

export class VehicleDto implements IVehicleDto {
    vehicleOwnershipType_Name?: string | undefined;
    year?: number;
    make?: string | undefined;
    model?: string | undefined;
    id?: number;
    assetCategoryType_Name?: string | undefined;
    assetType_Name?: string | undefined;
    origin_Name?: string | undefined;
    value?: number;
    description?: string | undefined;
    downPaymentValue?: number;
    applicants?: number[] | undefined;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleOwnershipType_Name = _data["vehicleOwnershipType_Name"];
            this.year = _data["year"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.id = _data["id"];
            this.assetCategoryType_Name = _data["assetCategoryType_Name"];
            this.assetType_Name = _data["assetType_Name"];
            this.origin_Name = _data["origin_Name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.downPaymentValue = _data["downPaymentValue"];
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(item);
            }
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleOwnershipType_Name"] = this.vehicleOwnershipType_Name;
        data["year"] = this.year;
        data["make"] = this.make;
        data["model"] = this.model;
        data["id"] = this.id;
        data["assetCategoryType_Name"] = this.assetCategoryType_Name;
        data["assetType_Name"] = this.assetType_Name;
        data["origin_Name"] = this.origin_Name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["downPaymentValue"] = this.downPaymentValue;
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item);
        }
        return data;
    }
}

export interface IVehicleDto {
    vehicleOwnershipType_Name?: string | undefined;
    year?: number;
    make?: string | undefined;
    model?: string | undefined;
    id?: number;
    assetCategoryType_Name?: string | undefined;
    assetType_Name?: string | undefined;
    origin_Name?: string | undefined;
    value?: number;
    description?: string | undefined;
    downPaymentValue?: number;
    applicants?: number[] | undefined;
}

export class PropertyExpenseDto implements IPropertyExpenseDto {
    assetId?: number;
    condoFeesAmount?: number | undefined;
    condoFeesFrequency?: string | undefined;
    insuranceAmount?: number | undefined;
    insuranceFrequency?: string | undefined;
    maintenanceAmount?: number | undefined;
    maintenanceFrequency?: string | undefined;
    managementFeeAmount?: number | undefined;
    managementFeeFrequency?: string | undefined;
    otherFeeAmount?: number | undefined;
    otherFeeFrequency?: string | undefined;
    utilityFeesAmount?: number | undefined;
    utilityFeesFrequency?: string | undefined;
    ownershipPercentage?: number | undefined;
    taxAmount?: number | undefined;
    taxFrequency?: string | undefined;
    id?: number;
    expenseCategoryType?: string | undefined;
    applicants?: number[] | undefined;

    constructor(data?: IPropertyExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.condoFeesAmount = _data["condoFeesAmount"];
            this.condoFeesFrequency = _data["condoFeesFrequency"];
            this.insuranceAmount = _data["insuranceAmount"];
            this.insuranceFrequency = _data["insuranceFrequency"];
            this.maintenanceAmount = _data["maintenanceAmount"];
            this.maintenanceFrequency = _data["maintenanceFrequency"];
            this.managementFeeAmount = _data["managementFeeAmount"];
            this.managementFeeFrequency = _data["managementFeeFrequency"];
            this.otherFeeAmount = _data["otherFeeAmount"];
            this.otherFeeFrequency = _data["otherFeeFrequency"];
            this.utilityFeesAmount = _data["utilityFeesAmount"];
            this.utilityFeesFrequency = _data["utilityFeesFrequency"];
            this.ownershipPercentage = _data["ownershipPercentage"];
            this.taxAmount = _data["taxAmount"];
            this.taxFrequency = _data["taxFrequency"];
            this.id = _data["id"];
            this.expenseCategoryType = _data["expenseCategoryType"];
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(item);
            }
        }
    }

    static fromJS(data: any): PropertyExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["condoFeesAmount"] = this.condoFeesAmount;
        data["condoFeesFrequency"] = this.condoFeesFrequency;
        data["insuranceAmount"] = this.insuranceAmount;
        data["insuranceFrequency"] = this.insuranceFrequency;
        data["maintenanceAmount"] = this.maintenanceAmount;
        data["maintenanceFrequency"] = this.maintenanceFrequency;
        data["managementFeeAmount"] = this.managementFeeAmount;
        data["managementFeeFrequency"] = this.managementFeeFrequency;
        data["otherFeeAmount"] = this.otherFeeAmount;
        data["otherFeeFrequency"] = this.otherFeeFrequency;
        data["utilityFeesAmount"] = this.utilityFeesAmount;
        data["utilityFeesFrequency"] = this.utilityFeesFrequency;
        data["ownershipPercentage"] = this.ownershipPercentage;
        data["taxAmount"] = this.taxAmount;
        data["taxFrequency"] = this.taxFrequency;
        data["id"] = this.id;
        data["expenseCategoryType"] = this.expenseCategoryType;
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item);
        }
        return data;
    }
}

export interface IPropertyExpenseDto {
    assetId?: number;
    condoFeesAmount?: number | undefined;
    condoFeesFrequency?: string | undefined;
    insuranceAmount?: number | undefined;
    insuranceFrequency?: string | undefined;
    maintenanceAmount?: number | undefined;
    maintenanceFrequency?: string | undefined;
    managementFeeAmount?: number | undefined;
    managementFeeFrequency?: string | undefined;
    otherFeeAmount?: number | undefined;
    otherFeeFrequency?: string | undefined;
    utilityFeesAmount?: number | undefined;
    utilityFeesFrequency?: string | undefined;
    ownershipPercentage?: number | undefined;
    taxAmount?: number | undefined;
    taxFrequency?: string | undefined;
    id?: number;
    expenseCategoryType?: string | undefined;
    applicants?: number[] | undefined;
}

export class FinancialInstitution implements IFinancialInstitution {
    id?: number | undefined;
    bankId?: number | undefined;
    name?: string | undefined;

    constructor(data?: IFinancialInstitution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FinancialInstitution {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialInstitution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["name"] = this.name;
        return data;
    }
}

export interface IFinancialInstitution {
    id?: number | undefined;
    bankId?: number | undefined;
    name?: string | undefined;
}

export class OccupationDto implements IOccupationDto {
    category?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;

    constructor(data?: IOccupationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): OccupationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OccupationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        return data;
    }
}

export interface IOccupationDto {
    category?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
}

export class MortgageApplicationForCreateDto implements IMortgageApplicationForCreateDto {
    mortgageApplicationType?: string | undefined;
    productCode?: string | undefined;
    purposeType?: string | undefined;
    securityType?: string | undefined;
    firstTimeHomeBuyer?: boolean;
    termInMonths?: number;
    amortizationInMonths?: number;
    remainingBalanceAmount?: number;
    downPaymentAmount?: number;
    newMoneyRequestedAmount?: number;
    totalLoanAmount?: number;
    purchasePrice?: number;
    propertySalePrice?: number;

    constructor(data?: IMortgageApplicationForCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mortgageApplicationType = _data["mortgageApplicationType"];
            this.productCode = _data["productCode"];
            this.purposeType = _data["purposeType"];
            this.securityType = _data["securityType"];
            this.firstTimeHomeBuyer = _data["firstTimeHomeBuyer"];
            this.termInMonths = _data["termInMonths"];
            this.amortizationInMonths = _data["amortizationInMonths"];
            this.remainingBalanceAmount = _data["remainingBalanceAmount"];
            this.downPaymentAmount = _data["downPaymentAmount"];
            this.newMoneyRequestedAmount = _data["newMoneyRequestedAmount"];
            this.totalLoanAmount = _data["totalLoanAmount"];
            this.purchasePrice = _data["purchasePrice"];
            this.propertySalePrice = _data["propertySalePrice"];
        }
    }

    static fromJS(data: any): MortgageApplicationForCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MortgageApplicationForCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mortgageApplicationType"] = this.mortgageApplicationType;
        data["productCode"] = this.productCode;
        data["purposeType"] = this.purposeType;
        data["securityType"] = this.securityType;
        data["firstTimeHomeBuyer"] = this.firstTimeHomeBuyer;
        data["termInMonths"] = this.termInMonths;
        data["amortizationInMonths"] = this.amortizationInMonths;
        data["remainingBalanceAmount"] = this.remainingBalanceAmount;
        data["downPaymentAmount"] = this.downPaymentAmount;
        data["newMoneyRequestedAmount"] = this.newMoneyRequestedAmount;
        data["totalLoanAmount"] = this.totalLoanAmount;
        data["purchasePrice"] = this.purchasePrice;
        data["propertySalePrice"] = this.propertySalePrice;
        return data;
    }
}

export interface IMortgageApplicationForCreateDto {
    mortgageApplicationType?: string | undefined;
    productCode?: string | undefined;
    purposeType?: string | undefined;
    securityType?: string | undefined;
    firstTimeHomeBuyer?: boolean;
    termInMonths?: number;
    amortizationInMonths?: number;
    remainingBalanceAmount?: number;
    downPaymentAmount?: number;
    newMoneyRequestedAmount?: number;
    totalLoanAmount?: number;
    purchasePrice?: number;
    propertySalePrice?: number;
}

export class MortgageApplicationForDisplayDto implements IMortgageApplicationForDisplayDto {
    applicationId?: number;
    id?: number;
    dealId?: number;
    mortgageApplicationType?: string | undefined;
    type?: string | undefined;
    purposeType?: string | undefined;
    securityType?: string | undefined;
    firstTimeHomeBuyer?: boolean;
    remainingBalanceAmount?: number;
    downPaymentAmount?: number;
    newMoneyRequestedAmount?: number;
    totalLoanAmount?: number;
    products?: MortgageProductDto[] | undefined;
    subjectProperty?: SubjectPropertyDto;

    constructor(data?: IMortgageApplicationForDisplayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.id = _data["id"];
            this.dealId = _data["dealId"];
            this.mortgageApplicationType = _data["mortgageApplicationType"];
            this.type = _data["type"];
            this.purposeType = _data["purposeType"];
            this.securityType = _data["securityType"];
            this.firstTimeHomeBuyer = _data["firstTimeHomeBuyer"];
            this.remainingBalanceAmount = _data["remainingBalanceAmount"];
            this.downPaymentAmount = _data["downPaymentAmount"];
            this.newMoneyRequestedAmount = _data["newMoneyRequestedAmount"];
            this.totalLoanAmount = _data["totalLoanAmount"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(MortgageProductDto.fromJS(item));
            }
            this.subjectProperty = _data["subjectProperty"] ? SubjectPropertyDto.fromJS(_data["subjectProperty"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MortgageApplicationForDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new MortgageApplicationForDisplayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["id"] = this.id;
        data["dealId"] = this.dealId;
        data["mortgageApplicationType"] = this.mortgageApplicationType;
        data["type"] = this.type;
        data["purposeType"] = this.purposeType;
        data["securityType"] = this.securityType;
        data["firstTimeHomeBuyer"] = this.firstTimeHomeBuyer;
        data["remainingBalanceAmount"] = this.remainingBalanceAmount;
        data["downPaymentAmount"] = this.downPaymentAmount;
        data["newMoneyRequestedAmount"] = this.newMoneyRequestedAmount;
        data["totalLoanAmount"] = this.totalLoanAmount;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["subjectProperty"] = this.subjectProperty ? this.subjectProperty.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMortgageApplicationForDisplayDto {
    applicationId?: number;
    id?: number;
    dealId?: number;
    mortgageApplicationType?: string | undefined;
    type?: string | undefined;
    purposeType?: string | undefined;
    securityType?: string | undefined;
    firstTimeHomeBuyer?: boolean;
    remainingBalanceAmount?: number;
    downPaymentAmount?: number;
    newMoneyRequestedAmount?: number;
    totalLoanAmount?: number;
    products?: MortgageProductDto[] | undefined;
    subjectProperty?: SubjectPropertyDto;
}

export class MortgageProductDto implements IMortgageProductDto {
    termInMonths?: number;
    amortizationInMonths?: number;
    productCode?: string | undefined;
    productType?: string | undefined;

    constructor(data?: IMortgageProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termInMonths = _data["termInMonths"];
            this.amortizationInMonths = _data["amortizationInMonths"];
            this.productCode = _data["productCode"];
            this.productType = _data["productType"];
        }
    }

    static fromJS(data: any): MortgageProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new MortgageProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termInMonths"] = this.termInMonths;
        data["amortizationInMonths"] = this.amortizationInMonths;
        data["productCode"] = this.productCode;
        data["productType"] = this.productType;
        return data;
    }
}

export interface IMortgageProductDto {
    termInMonths?: number;
    amortizationInMonths?: number;
    productCode?: string | undefined;
    productType?: string | undefined;
}

export class PropertyForCreationDto implements IPropertyForCreationDto {
    name?: string | undefined;
    applicationId?: number;
    remainingBalanceAmount?: number;
    downPaymentAmount?: number;
    totalLoanAmount?: number;
    newMoneyRequestedAmount?: number;
    subjectProperty?: SubjectPropertyDto;

    constructor(data?: IPropertyForCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.applicationId = _data["applicationId"];
            this.remainingBalanceAmount = _data["remainingBalanceAmount"];
            this.downPaymentAmount = _data["downPaymentAmount"];
            this.totalLoanAmount = _data["totalLoanAmount"];
            this.newMoneyRequestedAmount = _data["newMoneyRequestedAmount"];
            this.subjectProperty = _data["subjectProperty"] ? SubjectPropertyDto.fromJS(_data["subjectProperty"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyForCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyForCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["applicationId"] = this.applicationId;
        data["remainingBalanceAmount"] = this.remainingBalanceAmount;
        data["downPaymentAmount"] = this.downPaymentAmount;
        data["totalLoanAmount"] = this.totalLoanAmount;
        data["newMoneyRequestedAmount"] = this.newMoneyRequestedAmount;
        data["subjectProperty"] = this.subjectProperty ? this.subjectProperty.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyForCreationDto {
    name?: string | undefined;
    applicationId?: number;
    remainingBalanceAmount?: number;
    downPaymentAmount?: number;
    totalLoanAmount?: number;
    newMoneyRequestedAmount?: number;
    subjectProperty?: SubjectPropertyDto;
}

export class PropertyForDisplayDto implements IPropertyForDisplayDto {
    id?: number;
    dealId?: number;
    mortgageApplicationType?: string | undefined;
    type?: string | undefined;
    purposeType?: string | undefined;
    securityType?: string | undefined;
    firstTimeHomeBuyer?: boolean;
    remainingBalanceAmount?: number;
    downPaymentAmount?: number;
    newMoneyRequestedAmount?: number;
    totalLoanAmount?: number;
    products?: MortgageProductDto[] | undefined;
    subjectProperty?: SubjectPropertyDto;

    constructor(data?: IPropertyForDisplayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dealId = _data["dealId"];
            this.mortgageApplicationType = _data["mortgageApplicationType"];
            this.type = _data["type"];
            this.purposeType = _data["purposeType"];
            this.securityType = _data["securityType"];
            this.firstTimeHomeBuyer = _data["firstTimeHomeBuyer"];
            this.remainingBalanceAmount = _data["remainingBalanceAmount"];
            this.downPaymentAmount = _data["downPaymentAmount"];
            this.newMoneyRequestedAmount = _data["newMoneyRequestedAmount"];
            this.totalLoanAmount = _data["totalLoanAmount"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(MortgageProductDto.fromJS(item));
            }
            this.subjectProperty = _data["subjectProperty"] ? SubjectPropertyDto.fromJS(_data["subjectProperty"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyForDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyForDisplayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dealId"] = this.dealId;
        data["mortgageApplicationType"] = this.mortgageApplicationType;
        data["type"] = this.type;
        data["purposeType"] = this.purposeType;
        data["securityType"] = this.securityType;
        data["firstTimeHomeBuyer"] = this.firstTimeHomeBuyer;
        data["remainingBalanceAmount"] = this.remainingBalanceAmount;
        data["downPaymentAmount"] = this.downPaymentAmount;
        data["newMoneyRequestedAmount"] = this.newMoneyRequestedAmount;
        data["totalLoanAmount"] = this.totalLoanAmount;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["subjectProperty"] = this.subjectProperty ? this.subjectProperty.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyForDisplayDto {
    id?: number;
    dealId?: number;
    mortgageApplicationType?: string | undefined;
    type?: string | undefined;
    purposeType?: string | undefined;
    securityType?: string | undefined;
    firstTimeHomeBuyer?: boolean;
    remainingBalanceAmount?: number;
    downPaymentAmount?: number;
    newMoneyRequestedAmount?: number;
    totalLoanAmount?: number;
    products?: MortgageProductDto[] | undefined;
    subjectProperty?: SubjectPropertyDto;
}

export class ReferralProductDto implements IReferralProductDto {
    description?: string | undefined;
    rate?: string | undefined;
    promoRate?: string | undefined;
    productId?: number;

    constructor(data?: IReferralProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.rate = _data["rate"];
            this.promoRate = _data["promoRate"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ReferralProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["rate"] = this.rate;
        data["promoRate"] = this.promoRate;
        data["productId"] = this.productId;
        return data;
    }
}

export interface IReferralProductDto {
    description?: string | undefined;
    rate?: string | undefined;
    promoRate?: string | undefined;
    productId?: number;
}

export class SubjectPropertyDto implements ISubjectPropertyDto {
    originalPurchasePrice?: number;
    purchasePrice?: number;
    propertySalePrice?: number;
    address?: AddressDto;
    propertyTax?: number;
    propertyTaxFrequency?: string | undefined;
    mortgageHolder?: string | undefined;
    livableArea?: number;
    livableAreaType?: string | undefined;
    heatingCost?: number;
    heatingType?: string | undefined;
    heatingCostFrequency?: string | undefined;
    condoFees?: number | undefined;
    condoFeesFrequency?: string | undefined;
    futureStatusOfProperty?: string | undefined;
    occupancyType?: string | undefined;
    subjectPropertyRentalUnits?: number;
    totalRentalUnits?: number;
    totalRentalProperties?: number;
    ownershipPercentage?: number | undefined;
    hasCurrentRentalProperties?: boolean | undefined;
    rentalIncome?: number | undefined;
    isPlanningOnRenting?: boolean | undefined;
    isSeparateLegalUnit?: boolean | undefined;
    rent?: number;
    estimatedFundingDate?: dayjs.Dayjs | undefined;
    closingDate?: dayjs.Dayjs;
    conditionOfFinancingDate?: dayjs.Dayjs | undefined;
    applicationId?: number;

    constructor(data?: ISubjectPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalPurchasePrice = _data["originalPurchasePrice"];
            this.purchasePrice = _data["purchasePrice"];
            this.propertySalePrice = _data["propertySalePrice"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.propertyTax = _data["propertyTax"];
            this.propertyTaxFrequency = _data["propertyTaxFrequency"];
            this.mortgageHolder = _data["mortgageHolder"];
            this.livableArea = _data["livableArea"];
            this.livableAreaType = _data["livableAreaType"];
            this.heatingCost = _data["heatingCost"];
            this.heatingType = _data["heatingType"];
            this.heatingCostFrequency = _data["heatingCostFrequency"];
            this.condoFees = _data["condoFees"];
            this.condoFeesFrequency = _data["condoFeesFrequency"];
            this.futureStatusOfProperty = _data["futureStatusOfProperty"];
            this.occupancyType = _data["occupancyType"];
            this.subjectPropertyRentalUnits = _data["subjectPropertyRentalUnits"];
            this.totalRentalUnits = _data["totalRentalUnits"];
            this.totalRentalProperties = _data["totalRentalProperties"];
            this.ownershipPercentage = _data["ownershipPercentage"];
            this.hasCurrentRentalProperties = _data["hasCurrentRentalProperties"];
            this.rentalIncome = _data["rentalIncome"];
            this.isPlanningOnRenting = _data["isPlanningOnRenting"];
            this.isSeparateLegalUnit = _data["isSeparateLegalUnit"];
            this.rent = _data["rent"];
            this.estimatedFundingDate = _data["estimatedFundingDate"] ? dayjs(_data["estimatedFundingDate"].toString()) : <any>undefined;
            this.closingDate = _data["closingDate"] ? dayjs(_data["closingDate"].toString()) : <any>undefined;
            this.conditionOfFinancingDate = _data["conditionOfFinancingDate"] ? dayjs(_data["conditionOfFinancingDate"].toString()) : <any>undefined;
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): SubjectPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalPurchasePrice"] = this.originalPurchasePrice;
        data["purchasePrice"] = this.purchasePrice;
        data["propertySalePrice"] = this.propertySalePrice;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["propertyTax"] = this.propertyTax;
        data["propertyTaxFrequency"] = this.propertyTaxFrequency;
        data["mortgageHolder"] = this.mortgageHolder;
        data["livableArea"] = this.livableArea;
        data["livableAreaType"] = this.livableAreaType;
        data["heatingCost"] = this.heatingCost;
        data["heatingType"] = this.heatingType;
        data["heatingCostFrequency"] = this.heatingCostFrequency;
        data["condoFees"] = this.condoFees;
        data["condoFeesFrequency"] = this.condoFeesFrequency;
        data["futureStatusOfProperty"] = this.futureStatusOfProperty;
        data["occupancyType"] = this.occupancyType;
        data["subjectPropertyRentalUnits"] = this.subjectPropertyRentalUnits;
        data["totalRentalUnits"] = this.totalRentalUnits;
        data["totalRentalProperties"] = this.totalRentalProperties;
        data["ownershipPercentage"] = this.ownershipPercentage;
        data["hasCurrentRentalProperties"] = this.hasCurrentRentalProperties;
        data["rentalIncome"] = this.rentalIncome;
        data["isPlanningOnRenting"] = this.isPlanningOnRenting;
        data["isSeparateLegalUnit"] = this.isSeparateLegalUnit;
        data["rent"] = this.rent;
        data["estimatedFundingDate"] = this.estimatedFundingDate ? this.estimatedFundingDate.toISOString() : <any>undefined;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["conditionOfFinancingDate"] = this.conditionOfFinancingDate ? this.conditionOfFinancingDate.toISOString() : <any>undefined;
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface ISubjectPropertyDto {
    originalPurchasePrice?: number;
    purchasePrice?: number;
    propertySalePrice?: number;
    address?: AddressDto;
    propertyTax?: number;
    propertyTaxFrequency?: string | undefined;
    mortgageHolder?: string | undefined;
    livableArea?: number;
    livableAreaType?: string | undefined;
    heatingCost?: number;
    heatingType?: string | undefined;
    heatingCostFrequency?: string | undefined;
    condoFees?: number | undefined;
    condoFeesFrequency?: string | undefined;
    futureStatusOfProperty?: string | undefined;
    occupancyType?: string | undefined;
    subjectPropertyRentalUnits?: number;
    totalRentalUnits?: number;
    totalRentalProperties?: number;
    ownershipPercentage?: number | undefined;
    hasCurrentRentalProperties?: boolean | undefined;
    rentalIncome?: number | undefined;
    isPlanningOnRenting?: boolean | undefined;
    isSeparateLegalUnit?: boolean | undefined;
    rent?: number;
    estimatedFundingDate?: dayjs.Dayjs | undefined;
    closingDate?: dayjs.Dayjs;
    conditionOfFinancingDate?: dayjs.Dayjs | undefined;
    applicationId?: number;
}

export class AddressDto implements IAddressDto {
    id?: number;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    streetType?: string | undefined;
    streetDirection?: string | undefined;
    /** Mapped from Ovation */
    unitType?: string | undefined;
    unitNumber?: string | undefined;
    city!: string;
    region?: string | undefined;
    postalCode?: string | undefined;
    country!: string;
    deliveryMode?: string | undefined;
    modeNumber?: string | undefined;
    deliveryMode2?: string | undefined;
    modeNumber2?: string | undefined;
    isMailing!: boolean;
    residenceStatusType_Name?: string | undefined;
    timeAtResidenceInMonths?: number;
    readonly addressLine1?: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.streetType = _data["streetType"];
            this.streetDirection = _data["streetDirection"];
            this.unitType = _data["unitType"];
            this.unitNumber = _data["unitNumber"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.deliveryMode = _data["deliveryMode"];
            this.modeNumber = _data["modeNumber"];
            this.deliveryMode2 = _data["deliveryMode2"];
            this.modeNumber2 = _data["modeNumber2"];
            this.isMailing = _data["isMailing"];
            this.residenceStatusType_Name = _data["residenceStatusType_Name"];
            this.timeAtResidenceInMonths = _data["timeAtResidenceInMonths"];
            (<any>this).addressLine1 = _data["addressLine1"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["streetType"] = this.streetType;
        data["streetDirection"] = this.streetDirection;
        data["unitType"] = this.unitType;
        data["unitNumber"] = this.unitNumber;
        data["city"] = this.city;
        data["region"] = this.region;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["deliveryMode"] = this.deliveryMode;
        data["modeNumber"] = this.modeNumber;
        data["deliveryMode2"] = this.deliveryMode2;
        data["modeNumber2"] = this.modeNumber2;
        data["isMailing"] = this.isMailing;
        data["residenceStatusType_Name"] = this.residenceStatusType_Name;
        data["timeAtResidenceInMonths"] = this.timeAtResidenceInMonths;
        data["addressLine1"] = this.addressLine1;
        return data;
    }
}

export interface IAddressDto {
    id?: number;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    streetType?: string | undefined;
    streetDirection?: string | undefined;
    /** Mapped from Ovation */
    unitType?: string | undefined;
    unitNumber?: string | undefined;
    city: string;
    region?: string | undefined;
    postalCode?: string | undefined;
    country: string;
    deliveryMode?: string | undefined;
    modeNumber?: string | undefined;
    deliveryMode2?: string | undefined;
    modeNumber2?: string | undefined;
    isMailing: boolean;
    residenceStatusType_Name?: string | undefined;
    timeAtResidenceInMonths?: number;
    addressLine1?: string | undefined;
}

export class UpdatePasswordDto implements IUpdatePasswordDto {
    password!: string;
    applicantId?: number;
    expiresInDays?: number;
    clientToken?: string | undefined;

    constructor(data?: IUpdatePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.applicantId = _data["applicantId"];
            this.expiresInDays = _data["expiresInDays"];
            this.clientToken = _data["clientToken"];
        }
    }

    static fromJS(data: any): UpdatePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["applicantId"] = this.applicantId;
        data["expiresInDays"] = this.expiresInDays;
        data["clientToken"] = this.clientToken;
        return data;
    }
}

export interface IUpdatePasswordDto {
    password: string;
    applicantId?: number;
    expiresInDays?: number;
    clientToken?: string | undefined;
}

export class UserDto implements IUserDto {
    email!: string;
    password!: string;
    clientToken?: string | undefined;
    docIqToken?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.clientToken = _data["clientToken"];
            this.docIqToken = _data["docIqToken"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["clientToken"] = this.clientToken;
        data["docIqToken"] = this.docIqToken;
        return data;
    }
}

export interface IUserDto {
    email: string;
    password: string;
    clientToken?: string | undefined;
    docIqToken?: string | undefined;
}

export class Address implements IAddress {
    type?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    streetType?: string | undefined;
    streetDirection?: string | undefined;
    unitNumber?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.streetType = _data["streetType"];
            this.streetDirection = _data["streetDirection"];
            this.unitNumber = _data["unitNumber"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["streetType"] = this.streetType;
        data["streetDirection"] = this.streetDirection;
        data["unitNumber"] = this.unitNumber;
        data["city"] = this.city;
        data["region"] = this.region;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    }
}

export interface IAddress {
    type?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    streetType?: string | undefined;
    streetDirection?: string | undefined;
    unitNumber?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
}

export class ApplicantAddressDto implements IApplicantAddressDto {
    id?: number | undefined;
    applicantId?: number | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    streetType?: string | undefined;
    streetDirection?: string | undefined;
    unitType?: string | undefined;
    unitNumber?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    deliveryMode?: string | undefined;
    modeNumber?: string | undefined;
    deliveryMode2?: string | undefined;
    modeNumber2?: string | undefined;
    isMailing?: boolean | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;

    constructor(data?: IApplicantAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicantId = _data["applicantId"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.streetType = _data["streetType"];
            this.streetDirection = _data["streetDirection"];
            this.unitType = _data["unitType"];
            this.unitNumber = _data["unitNumber"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.deliveryMode = _data["deliveryMode"];
            this.modeNumber = _data["modeNumber"];
            this.deliveryMode2 = _data["deliveryMode2"];
            this.modeNumber2 = _data["modeNumber2"];
            this.isMailing = _data["isMailing"];
            this.modifiedByUser = _data["modifiedByUser"];
            this.modifiedDate = _data["modifiedDate"] ? dayjs(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicantAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicantId"] = this.applicantId;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["streetType"] = this.streetType;
        data["streetDirection"] = this.streetDirection;
        data["unitType"] = this.unitType;
        data["unitNumber"] = this.unitNumber;
        data["city"] = this.city;
        data["region"] = this.region;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["deliveryMode"] = this.deliveryMode;
        data["modeNumber"] = this.modeNumber;
        data["deliveryMode2"] = this.deliveryMode2;
        data["modeNumber2"] = this.modeNumber2;
        data["isMailing"] = this.isMailing;
        data["modifiedByUser"] = this.modifiedByUser;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApplicantAddressDto {
    id?: number | undefined;
    applicantId?: number | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    streetType?: string | undefined;
    streetDirection?: string | undefined;
    unitType?: string | undefined;
    unitNumber?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    deliveryMode?: string | undefined;
    modeNumber?: string | undefined;
    deliveryMode2?: string | undefined;
    modeNumber2?: string | undefined;
    isMailing?: boolean | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
}

export class ApplicantDto implements IApplicantDto {
    id?: number | undefined;
    addresses?: ApplicantAddressDto[] | undefined;
    complianceInfo?: ComplianceDto;
    legalFirstName?: string | undefined;
    legalLastName?: string | undefined;
    middleName?: string | undefined;
    dateOfBirth?: dayjs.Dayjs | undefined;
    sin?: number | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    phoneType?: string | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;

    constructor(data?: IApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(ApplicantAddressDto.fromJS(item));
            }
            this.complianceInfo = _data["complianceInfo"] ? ComplianceDto.fromJS(_data["complianceInfo"]) : <any>undefined;
            this.legalFirstName = _data["legalFirstName"];
            this.legalLastName = _data["legalLastName"];
            this.middleName = _data["middleName"];
            this.dateOfBirth = _data["dateOfBirth"] ? dayjs(_data["dateOfBirth"].toString()) : <any>undefined;
            this.sin = _data["sin"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneType = _data["phoneType"];
            this.modifiedByUser = _data["modifiedByUser"];
            this.modifiedDate = _data["modifiedDate"] ? dayjs(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["complianceInfo"] = this.complianceInfo ? this.complianceInfo.toJSON() : <any>undefined;
        data["legalFirstName"] = this.legalFirstName;
        data["legalLastName"] = this.legalLastName;
        data["middleName"] = this.middleName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["sin"] = this.sin;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneType"] = this.phoneType;
        data["modifiedByUser"] = this.modifiedByUser;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApplicantDto {
    id?: number | undefined;
    addresses?: ApplicantAddressDto[] | undefined;
    complianceInfo?: ComplianceDto;
    legalFirstName?: string | undefined;
    legalLastName?: string | undefined;
    middleName?: string | undefined;
    dateOfBirth?: dayjs.Dayjs | undefined;
    sin?: number | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    phoneType?: string | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
}

export class BlockListSearchResponse implements IBlockListSearchResponse {
    blockListFound?: boolean | undefined;

    constructor(data?: IBlockListSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blockListFound = _data["blockListFound"];
        }
    }

    static fromJS(data: any): BlockListSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BlockListSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blockListFound"] = this.blockListFound;
        return data;
    }
}

export interface IBlockListSearchResponse {
    blockListFound?: boolean | undefined;
}

export class ComplianceDto implements IComplianceDto {
    id?: number | undefined;
    fatcaReportingStatusType?: string | undefined;
    fatcaTinType?: string | undefined;
    fatcaTinNumber?: string | undefined;
    crsReportingStatusType?: string | undefined;
    isUsCitizen?: boolean | undefined;
    isUsResident?: boolean | undefined;
    isCanadianTaxResident?: boolean | undefined;
    isTaxResidentOutsideCanUsa?: boolean | undefined;
    crsCountry?: string | undefined;
    crsTinNumber?: string | undefined;
    noTinReasonType?: string | undefined;
    reasonIfOther?: string | undefined;
    crsCountry2?: string | undefined;
    crsTinNumber2?: string | undefined;
    noTinReasonType2?: string | undefined;
    reasonIfOther2?: string | undefined;
    liveInCanada?: boolean | undefined;
    workInCanada?: boolean | undefined;
    ownerOperator?: boolean | undefined;
    financialRelationshipType?: string | undefined;
    meridianRelationshipType?: string | undefined;
    isPoliticallyExposed?: boolean | undefined;
    positionOfOfficeHeld?: string | undefined;
    nameOfGovernmentInstitution?: string | undefined;
    governmentLevelType?: string | undefined;
    countryPositionOfOfficeHeld?: string | undefined;
    isFamilyMemberPoliticallyExposed?: boolean | undefined;
    exposedFamilyType?: string | undefined;
    familyPositionOfOfficeHeld?: string | undefined;
    familyNameOfGovernmentInstitution?: string | undefined;
    familyGovernmentLevelType?: string | undefined;
    familyCountryPositionOfOfficeHeld?: string | undefined;

    constructor(data?: IComplianceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fatcaReportingStatusType = _data["fatcaReportingStatusType"];
            this.fatcaTinType = _data["fatcaTinType"];
            this.fatcaTinNumber = _data["fatcaTinNumber"];
            this.crsReportingStatusType = _data["crsReportingStatusType"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.isUsResident = _data["isUsResident"];
            this.isCanadianTaxResident = _data["isCanadianTaxResident"];
            this.isTaxResidentOutsideCanUsa = _data["isTaxResidentOutsideCanUsa"];
            this.crsCountry = _data["crsCountry"];
            this.crsTinNumber = _data["crsTinNumber"];
            this.noTinReasonType = _data["noTinReasonType"];
            this.reasonIfOther = _data["reasonIfOther"];
            this.crsCountry2 = _data["crsCountry2"];
            this.crsTinNumber2 = _data["crsTinNumber2"];
            this.noTinReasonType2 = _data["noTinReasonType2"];
            this.reasonIfOther2 = _data["reasonIfOther2"];
            this.liveInCanada = _data["liveInCanada"];
            this.workInCanada = _data["workInCanada"];
            this.ownerOperator = _data["ownerOperator"];
            this.financialRelationshipType = _data["financialRelationshipType"];
            this.meridianRelationshipType = _data["meridianRelationshipType"];
            this.isPoliticallyExposed = _data["isPoliticallyExposed"];
            this.positionOfOfficeHeld = _data["positionOfOfficeHeld"];
            this.nameOfGovernmentInstitution = _data["nameOfGovernmentInstitution"];
            this.governmentLevelType = _data["governmentLevelType"];
            this.countryPositionOfOfficeHeld = _data["countryPositionOfOfficeHeld"];
            this.isFamilyMemberPoliticallyExposed = _data["isFamilyMemberPoliticallyExposed"];
            this.exposedFamilyType = _data["exposedFamilyType"];
            this.familyPositionOfOfficeHeld = _data["familyPositionOfOfficeHeld"];
            this.familyNameOfGovernmentInstitution = _data["familyNameOfGovernmentInstitution"];
            this.familyGovernmentLevelType = _data["familyGovernmentLevelType"];
            this.familyCountryPositionOfOfficeHeld = _data["familyCountryPositionOfOfficeHeld"];
        }
    }

    static fromJS(data: any): ComplianceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComplianceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fatcaReportingStatusType"] = this.fatcaReportingStatusType;
        data["fatcaTinType"] = this.fatcaTinType;
        data["fatcaTinNumber"] = this.fatcaTinNumber;
        data["crsReportingStatusType"] = this.crsReportingStatusType;
        data["isUsCitizen"] = this.isUsCitizen;
        data["isUsResident"] = this.isUsResident;
        data["isCanadianTaxResident"] = this.isCanadianTaxResident;
        data["isTaxResidentOutsideCanUsa"] = this.isTaxResidentOutsideCanUsa;
        data["crsCountry"] = this.crsCountry;
        data["crsTinNumber"] = this.crsTinNumber;
        data["noTinReasonType"] = this.noTinReasonType;
        data["reasonIfOther"] = this.reasonIfOther;
        data["crsCountry2"] = this.crsCountry2;
        data["crsTinNumber2"] = this.crsTinNumber2;
        data["noTinReasonType2"] = this.noTinReasonType2;
        data["reasonIfOther2"] = this.reasonIfOther2;
        data["liveInCanada"] = this.liveInCanada;
        data["workInCanada"] = this.workInCanada;
        data["ownerOperator"] = this.ownerOperator;
        data["financialRelationshipType"] = this.financialRelationshipType;
        data["meridianRelationshipType"] = this.meridianRelationshipType;
        data["isPoliticallyExposed"] = this.isPoliticallyExposed;
        data["positionOfOfficeHeld"] = this.positionOfOfficeHeld;
        data["nameOfGovernmentInstitution"] = this.nameOfGovernmentInstitution;
        data["governmentLevelType"] = this.governmentLevelType;
        data["countryPositionOfOfficeHeld"] = this.countryPositionOfOfficeHeld;
        data["isFamilyMemberPoliticallyExposed"] = this.isFamilyMemberPoliticallyExposed;
        data["exposedFamilyType"] = this.exposedFamilyType;
        data["familyPositionOfOfficeHeld"] = this.familyPositionOfOfficeHeld;
        data["familyNameOfGovernmentInstitution"] = this.familyNameOfGovernmentInstitution;
        data["familyGovernmentLevelType"] = this.familyGovernmentLevelType;
        data["familyCountryPositionOfOfficeHeld"] = this.familyCountryPositionOfOfficeHeld;
        return data;
    }
}

export interface IComplianceDto {
    id?: number | undefined;
    fatcaReportingStatusType?: string | undefined;
    fatcaTinType?: string | undefined;
    fatcaTinNumber?: string | undefined;
    crsReportingStatusType?: string | undefined;
    isUsCitizen?: boolean | undefined;
    isUsResident?: boolean | undefined;
    isCanadianTaxResident?: boolean | undefined;
    isTaxResidentOutsideCanUsa?: boolean | undefined;
    crsCountry?: string | undefined;
    crsTinNumber?: string | undefined;
    noTinReasonType?: string | undefined;
    reasonIfOther?: string | undefined;
    crsCountry2?: string | undefined;
    crsTinNumber2?: string | undefined;
    noTinReasonType2?: string | undefined;
    reasonIfOther2?: string | undefined;
    liveInCanada?: boolean | undefined;
    workInCanada?: boolean | undefined;
    ownerOperator?: boolean | undefined;
    financialRelationshipType?: string | undefined;
    meridianRelationshipType?: string | undefined;
    isPoliticallyExposed?: boolean | undefined;
    positionOfOfficeHeld?: string | undefined;
    nameOfGovernmentInstitution?: string | undefined;
    governmentLevelType?: string | undefined;
    countryPositionOfOfficeHeld?: string | undefined;
    isFamilyMemberPoliticallyExposed?: boolean | undefined;
    exposedFamilyType?: string | undefined;
    familyPositionOfOfficeHeld?: string | undefined;
    familyNameOfGovernmentInstitution?: string | undefined;
    familyGovernmentLevelType?: string | undefined;
    familyCountryPositionOfOfficeHeld?: string | undefined;
}

export class DocumentDto implements IDocumentDto {
    id?: number | undefined;
    identificationId?: number | undefined;
    identification?: IdentificationDto;
    name?: string | undefined;
    sharePointDocumentId?: string | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identificationId = _data["identificationId"];
            this.identification = _data["identification"] ? IdentificationDto.fromJS(_data["identification"]) : <any>undefined;
            this.name = _data["name"];
            this.sharePointDocumentId = _data["sharePointDocumentId"];
            this.modifiedByUser = _data["modifiedByUser"];
            this.modifiedDate = _data["modifiedDate"] ? dayjs(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identificationId"] = this.identificationId;
        data["identification"] = this.identification ? this.identification.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["sharePointDocumentId"] = this.sharePointDocumentId;
        data["modifiedByUser"] = this.modifiedByUser;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentDto {
    id?: number | undefined;
    identificationId?: number | undefined;
    identification?: IdentificationDto;
    name?: string | undefined;
    sharePointDocumentId?: string | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
}

export class IDVNotificationDTO implements IIDVNotificationDTO {
    verificationRequestId?: number | undefined;
    applicantId?: number | undefined;
    serviceApplicantId?: string | undefined;
    idDesc?: string | undefined;
    status?: string | undefined;

    constructor(data?: IIDVNotificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationRequestId = _data["verificationRequestId"];
            this.applicantId = _data["applicantId"];
            this.serviceApplicantId = _data["serviceApplicantId"];
            this.idDesc = _data["idDesc"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): IDVNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IDVNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationRequestId"] = this.verificationRequestId;
        data["applicantId"] = this.applicantId;
        data["serviceApplicantId"] = this.serviceApplicantId;
        data["idDesc"] = this.idDesc;
        data["status"] = this.status;
        return data;
    }
}

export interface IIDVNotificationDTO {
    verificationRequestId?: number | undefined;
    applicantId?: number | undefined;
    serviceApplicantId?: string | undefined;
    idDesc?: string | undefined;
    status?: string | undefined;
}

export class IdentificationDto implements IIdentificationDto {
    id?: number | undefined;
    applicantId?: number | undefined;
    applicant?: ApplicantDto;
    idType?: number | undefined;
    idDesc?: string | undefined;
    photoId?: string | undefined;
    idNumber?: string | undefined;
    issuingRegion?: string | undefined;
    issuingCountry?: string | undefined;
    status?: string | undefined;
    statusChangedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    modifiedByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    expiryDate?: dayjs.Dayjs | undefined;
    documents?: DocumentDto[] | undefined;

    constructor(data?: IIdentificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicantId = _data["applicantId"];
            this.applicant = _data["applicant"] ? ApplicantDto.fromJS(_data["applicant"]) : <any>undefined;
            this.idType = _data["idType"];
            this.idDesc = _data["idDesc"];
            this.photoId = _data["photoId"];
            this.idNumber = _data["idNumber"];
            this.issuingRegion = _data["issuingRegion"];
            this.issuingCountry = _data["issuingCountry"];
            this.status = _data["status"];
            this.statusChangedDate = _data["statusChangedDate"] ? dayjs(_data["statusChangedDate"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"];
            this.modifiedByUser = _data["modifiedByUser"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? dayjs(_data["modifiedDate"].toString()) : <any>undefined;
            this.expiryDate = _data["expiryDate"] ? dayjs(_data["expiryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicantId"] = this.applicantId;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["idType"] = this.idType;
        data["idDesc"] = this.idDesc;
        data["photoId"] = this.photoId;
        data["idNumber"] = this.idNumber;
        data["issuingRegion"] = this.issuingRegion;
        data["issuingCountry"] = this.issuingCountry;
        data["status"] = this.status;
        data["statusChangedDate"] = this.statusChangedDate ? this.statusChangedDate.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        data["modifiedByUser"] = this.modifiedByUser;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIdentificationDto {
    id?: number | undefined;
    applicantId?: number | undefined;
    applicant?: ApplicantDto;
    idType?: number | undefined;
    idDesc?: string | undefined;
    photoId?: string | undefined;
    idNumber?: string | undefined;
    issuingRegion?: string | undefined;
    issuingCountry?: string | undefined;
    status?: string | undefined;
    statusChangedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    modifiedByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    expiryDate?: dayjs.Dayjs | undefined;
    documents?: DocumentDto[] | undefined;
}

export class ServiceDto implements IServiceDto {
    id?: number | undefined;
    serviceName?: string | undefined;
    webHookUrl?: string | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;

    constructor(data?: IServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceName = _data["serviceName"];
            this.webHookUrl = _data["webHookUrl"];
            this.createdByUser = _data["createdByUser"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedByUser = _data["modifiedByUser"];
            this.modifiedDate = _data["modifiedDate"] ? dayjs(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceName"] = this.serviceName;
        data["webHookUrl"] = this.webHookUrl;
        data["createdByUser"] = this.createdByUser;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedByUser"] = this.modifiedByUser;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IServiceDto {
    id?: number | undefined;
    serviceName?: string | undefined;
    webHookUrl?: string | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
}

export class VerificationRequestDto implements IVerificationRequestDto {
    id?: number | undefined;
    applicantId?: number | undefined;
    applicant?: ApplicantDto;
    identificationId?: number | undefined;
    identification?: IdentificationDto;
    idDesc?: string | undefined;
    skipAML?: boolean | undefined;
    status?: string | undefined;
    statusChangedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    notifications?: VerificationRequestNotificationDto[] | undefined;

    constructor(data?: IVerificationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicantId = _data["applicantId"];
            this.applicant = _data["applicant"] ? ApplicantDto.fromJS(_data["applicant"]) : <any>undefined;
            this.identificationId = _data["identificationId"];
            this.identification = _data["identification"] ? IdentificationDto.fromJS(_data["identification"]) : <any>undefined;
            this.idDesc = _data["idDesc"];
            this.skipAML = _data["skipAML"];
            this.status = _data["status"];
            this.statusChangedDate = _data["statusChangedDate"] ? dayjs(_data["statusChangedDate"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedByUser = _data["modifiedByUser"];
            this.modifiedDate = _data["modifiedDate"] ? dayjs(_data["modifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(VerificationRequestNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VerificationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicantId"] = this.applicantId;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["identificationId"] = this.identificationId;
        data["identification"] = this.identification ? this.identification.toJSON() : <any>undefined;
        data["idDesc"] = this.idDesc;
        data["skipAML"] = this.skipAML;
        data["status"] = this.status;
        data["statusChangedDate"] = this.statusChangedDate ? this.statusChangedDate.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedByUser"] = this.modifiedByUser;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVerificationRequestDto {
    id?: number | undefined;
    applicantId?: number | undefined;
    applicant?: ApplicantDto;
    identificationId?: number | undefined;
    identification?: IdentificationDto;
    idDesc?: string | undefined;
    skipAML?: boolean | undefined;
    status?: string | undefined;
    statusChangedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    notifications?: VerificationRequestNotificationDto[] | undefined;
}

export class VerificationRequestNotificationDto implements IVerificationRequestNotificationDto {
    id?: number | undefined;
    serviceId?: number | undefined;
    service?: ServiceDto;
    verificationRequestId?: number | undefined;
    verificationRequest?: VerificationRequestDto;
    serviceCallbackUrl?: string | undefined;
    serviceApplicantId?: string | undefined;
    notificationAttempts?: number | undefined;
    notificationDate?: dayjs.Dayjs | undefined;
    status?: string | undefined;
    statusChangedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;

    constructor(data?: IVerificationRequestNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
            this.verificationRequestId = _data["verificationRequestId"];
            this.verificationRequest = _data["verificationRequest"] ? VerificationRequestDto.fromJS(_data["verificationRequest"]) : <any>undefined;
            this.serviceCallbackUrl = _data["serviceCallbackUrl"];
            this.serviceApplicantId = _data["serviceApplicantId"];
            this.notificationAttempts = _data["notificationAttempts"];
            this.notificationDate = _data["notificationDate"] ? dayjs(_data["notificationDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusChangedDate = _data["statusChangedDate"] ? dayjs(_data["statusChangedDate"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedByUser = _data["modifiedByUser"];
            this.modifiedDate = _data["modifiedDate"] ? dayjs(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VerificationRequestNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationRequestNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["verificationRequestId"] = this.verificationRequestId;
        data["verificationRequest"] = this.verificationRequest ? this.verificationRequest.toJSON() : <any>undefined;
        data["serviceCallbackUrl"] = this.serviceCallbackUrl;
        data["serviceApplicantId"] = this.serviceApplicantId;
        data["notificationAttempts"] = this.notificationAttempts;
        data["notificationDate"] = this.notificationDate ? this.notificationDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusChangedDate"] = this.statusChangedDate ? this.statusChangedDate.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedByUser"] = this.modifiedByUser;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVerificationRequestNotificationDto {
    id?: number | undefined;
    serviceId?: number | undefined;
    service?: ServiceDto;
    verificationRequestId?: number | undefined;
    verificationRequest?: VerificationRequestDto;
    serviceCallbackUrl?: string | undefined;
    serviceApplicantId?: string | undefined;
    notificationAttempts?: number | undefined;
    notificationDate?: dayjs.Dayjs | undefined;
    status?: string | undefined;
    statusChangedDate?: dayjs.Dayjs | undefined;
    createdByUser?: string | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedByUser?: string | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
}

export class Challenge2FA implements IChallenge2FA {
    notificationChannel?: TwoFANotificationChannel;
    phone?: string | undefined;
    codeLength?: number;

    constructor(data?: IChallenge2FA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationChannel = _data["notificationChannel"];
            this.phone = _data["phone"];
            this.codeLength = _data["codeLength"];
        }
    }

    static fromJS(data: any): Challenge2FA {
        data = typeof data === 'object' ? data : {};
        let result = new Challenge2FA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationChannel"] = this.notificationChannel;
        data["phone"] = this.phone;
        data["codeLength"] = this.codeLength;
        return data;
    }
}

export interface IChallenge2FA {
    notificationChannel?: TwoFANotificationChannel;
    phone?: string | undefined;
    codeLength?: number;
}

export class ChallengeQuestion implements IChallengeQuestion {
    question?: string | undefined;

    constructor(data?: IChallengeQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
        }
    }

    static fromJS(data: any): ChallengeQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        return data;
    }
}

export interface IChallengeQuestion {
    question?: string | undefined;
}

export enum TwoFANotificationChannel {
    SMS = "SMS",
    Voice = "Voice",
}

export class DMDConfigType implements IDMDConfigType {

    constructor(data?: IDMDConfigType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DMDConfigType {
        data = typeof data === 'object' ? data : {};
        let result = new DMDConfigType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDMDConfigType {
}

export class LoanConfigType implements ILoanConfigType {
    rateType?: string | undefined;
    locType?: LocTypeEnum;
    promoRate?: number;
    termYrs?: number;
    termMos?: number;
    productRate?: number;
    prepayType?: PrepayTypeEnum;

    constructor(data?: ILoanConfigType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateType = _data["rateType"];
            this.locType = _data["locType"];
            this.promoRate = _data["promoRate"];
            this.termYrs = _data["termYrs"];
            this.termMos = _data["termMos"];
            this.productRate = _data["productRate"];
            this.prepayType = _data["prepayType"];
        }
    }

    static fromJS(data: any): LoanConfigType {
        data = typeof data === 'object' ? data : {};
        let result = new LoanConfigType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateType"] = this.rateType;
        data["locType"] = this.locType;
        data["promoRate"] = this.promoRate;
        data["termYrs"] = this.termYrs;
        data["termMos"] = this.termMos;
        data["productRate"] = this.productRate;
        data["prepayType"] = this.prepayType;
        return data;
    }
}

export interface ILoanConfigType {
    rateType?: string | undefined;
    locType?: LocTypeEnum;
    promoRate?: number;
    termYrs?: number;
    termMos?: number;
    productRate?: number;
    prepayType?: PrepayTypeEnum;
}

export enum MDTypeEnum {
    Renew = "Renew",
    Mature = "Mature",
    Rollover = "Rollover",
    RolloverCustom = "RolloverCustom",
    Transfer = "Transfer",
}

export class OnlineAccountDetailType implements IOnlineAccountDetailType {
    productID?: string | undefined;
    productCode?: string | undefined;
    accountCategory?: AccountCategoryEnum;
    description?: string | undefined;
    benefit?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    line4?: string | undefined;
    line5?: string | undefined;
    prodInfo1?: string | undefined;
    prodInfo2?: string | undefined;
    applyNowURL?: string | undefined;
    featured?: YesNoEnum;
    moreInfoURL?: string | undefined;
    dispOrder?: number;
    displayin?: DisplayinEnum;
    isInterestBearing?: YesNoEnum;
    dmdConfig?: DMDConfigType;
    loanConfig?: LoanConfigType;
    termConfig?: TermConfigType;

    constructor(data?: IOnlineAccountDetailType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.productCode = _data["productCode"];
            this.accountCategory = _data["accountCategory"];
            this.description = _data["description"];
            this.benefit = _data["benefit"];
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.line3 = _data["line3"];
            this.line4 = _data["line4"];
            this.line5 = _data["line5"];
            this.prodInfo1 = _data["prodInfo1"];
            this.prodInfo2 = _data["prodInfo2"];
            this.applyNowURL = _data["applyNowURL"];
            this.featured = _data["featured"];
            this.moreInfoURL = _data["moreInfoURL"];
            this.dispOrder = _data["dispOrder"];
            this.displayin = _data["displayin"];
            this.isInterestBearing = _data["isInterestBearing"];
            this.dmdConfig = _data["dmdConfig"] ? DMDConfigType.fromJS(_data["dmdConfig"]) : <any>undefined;
            this.loanConfig = _data["loanConfig"] ? LoanConfigType.fromJS(_data["loanConfig"]) : <any>undefined;
            this.termConfig = _data["termConfig"] ? TermConfigType.fromJS(_data["termConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OnlineAccountDetailType {
        data = typeof data === 'object' ? data : {};
        let result = new OnlineAccountDetailType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["productCode"] = this.productCode;
        data["accountCategory"] = this.accountCategory;
        data["description"] = this.description;
        data["benefit"] = this.benefit;
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["line3"] = this.line3;
        data["line4"] = this.line4;
        data["line5"] = this.line5;
        data["prodInfo1"] = this.prodInfo1;
        data["prodInfo2"] = this.prodInfo2;
        data["applyNowURL"] = this.applyNowURL;
        data["featured"] = this.featured;
        data["moreInfoURL"] = this.moreInfoURL;
        data["dispOrder"] = this.dispOrder;
        data["displayin"] = this.displayin;
        data["isInterestBearing"] = this.isInterestBearing;
        data["dmdConfig"] = this.dmdConfig ? this.dmdConfig.toJSON() : <any>undefined;
        data["loanConfig"] = this.loanConfig ? this.loanConfig.toJSON() : <any>undefined;
        data["termConfig"] = this.termConfig ? this.termConfig.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOnlineAccountDetailType {
    productID?: string | undefined;
    productCode?: string | undefined;
    accountCategory?: AccountCategoryEnum;
    description?: string | undefined;
    benefit?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    line4?: string | undefined;
    line5?: string | undefined;
    prodInfo1?: string | undefined;
    prodInfo2?: string | undefined;
    applyNowURL?: string | undefined;
    featured?: YesNoEnum;
    moreInfoURL?: string | undefined;
    dispOrder?: number;
    displayin?: DisplayinEnum;
    isInterestBearing?: YesNoEnum;
    dmdConfig?: DMDConfigType;
    loanConfig?: LoanConfigType;
    termConfig?: TermConfigType;
}

export class RateType implements IRateType {
    period?: number;
    description?: string | undefined;
    periodType?: PeriodTypEnum;
    rate?: number;

    constructor(data?: IRateType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.description = _data["description"];
            this.periodType = _data["periodType"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): RateType {
        data = typeof data === 'object' ? data : {};
        let result = new RateType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["description"] = this.description;
        data["periodType"] = this.periodType;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IRateType {
    period?: number;
    description?: string | undefined;
    periodType?: PeriodTypEnum;
    rate?: number;
}

export class TermConfigType implements ITermConfigType {
    isFixedLength?: YesNoEnum;
    defaultLength?: number;
    maxLength?: number;
    minAmount?: number;
    maxAmount?: number;
    mdDefault?: MDTypeEnum;
    mdAllowRenew?: YesNoEnum;
    mdAllowTransfer?: YesNoEnum;
    mdAllowCheque?: YesNoEnum;
    mdAllowMature?: YesNoEnum;
    mdAllowRollover?: YesNoEnum;
    intSchedule?: string | undefined;
    interestDP?: string | undefined;
    termRate?: RateType[] | undefined;

    constructor(data?: ITermConfigType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFixedLength = _data["isFixedLength"];
            this.defaultLength = _data["defaultLength"];
            this.maxLength = _data["maxLength"];
            this.minAmount = _data["minAmount"];
            this.maxAmount = _data["maxAmount"];
            this.mdDefault = _data["mdDefault"];
            this.mdAllowRenew = _data["mdAllowRenew"];
            this.mdAllowTransfer = _data["mdAllowTransfer"];
            this.mdAllowCheque = _data["mdAllowCheque"];
            this.mdAllowMature = _data["mdAllowMature"];
            this.mdAllowRollover = _data["mdAllowRollover"];
            this.intSchedule = _data["intSchedule"];
            this.interestDP = _data["interestDP"];
            if (Array.isArray(_data["termRate"])) {
                this.termRate = [] as any;
                for (let item of _data["termRate"])
                    this.termRate!.push(RateType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TermConfigType {
        data = typeof data === 'object' ? data : {};
        let result = new TermConfigType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFixedLength"] = this.isFixedLength;
        data["defaultLength"] = this.defaultLength;
        data["maxLength"] = this.maxLength;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        data["mdDefault"] = this.mdDefault;
        data["mdAllowRenew"] = this.mdAllowRenew;
        data["mdAllowTransfer"] = this.mdAllowTransfer;
        data["mdAllowCheque"] = this.mdAllowCheque;
        data["mdAllowMature"] = this.mdAllowMature;
        data["mdAllowRollover"] = this.mdAllowRollover;
        data["intSchedule"] = this.intSchedule;
        data["interestDP"] = this.interestDP;
        if (Array.isArray(this.termRate)) {
            data["termRate"] = [];
            for (let item of this.termRate)
                data["termRate"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITermConfigType {
    isFixedLength?: YesNoEnum;
    defaultLength?: number;
    maxLength?: number;
    minAmount?: number;
    maxAmount?: number;
    mdDefault?: MDTypeEnum;
    mdAllowRenew?: YesNoEnum;
    mdAllowTransfer?: YesNoEnum;
    mdAllowCheque?: YesNoEnum;
    mdAllowMature?: YesNoEnum;
    mdAllowRollover?: YesNoEnum;
    intSchedule?: string | undefined;
    interestDP?: string | undefined;
    termRate?: RateType[] | undefined;
}

export enum AccountCategoryEnum {
    Chequing = "Chequing",
    Savings = "Savings",
    USChequing = "USChequing",
    GIC = "GIC",
    TFSA = "TFSA",
    RRSP = "RRSP",
    FHSA = "FHSA",
    RIF = "RIF",
    Mortgage = "Mortgage",
    Loan = "Loan",
    LOC = "LOC",
    CreditCard = "CreditCard",
    Other = "Other",
}

export enum DisplayinEnum {
    Retail = "Retail",
    NA = "NA",
    Retail1 = "Retail1",
    Onboarding = "Onboarding",
    OnboardingRetail = "OnboardingRetail",
    SmallBusiness = "SmallBusiness",
    SmallBusinessBDS = "SmallBusinessBDS",
}

export enum LocTypeEnum {
    Item = "Item",
    Secured = "Secured",
    Unsecured = "Unsecured",
    Student = "Student",
    Equity = "Equity",
}

export enum PeriodTypEnum {
    Months = "Months",
    Years = "Years",
    Days = "Days",
}

export enum PrepayTypeEnum {
    Item = "Item",
    Cl = "cl",
    Op = "op",
}

export enum YesNoEnum {
    Yes = "Yes",
    No = "No",
}

export class IActionResult implements IIActionResult {

    constructor(data?: IIActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new IActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIActionResult {
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class AuthenticatedApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isAuthenticatedApiException = true;

    static isAuthenticatedApiException(obj: any): obj is AuthenticatedApiException {
        return obj.isAuthenticatedApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new AuthenticatedApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}